const fr = {
	"401": {
		"oops": "Oops!",
		"noAuth": "Vous n'êtes pas autorisé à accéder à la page",
		"goback": "Page précédente page suivante",
		"gohome": "La page de couverture"
	},
	"404": {
		"notFound": "Page introuvable"
	},
	"version": {
		"to_old": "Retour à l'ancienne édition",
		"to_new": "Retour à la nouvelle édition",
		"default_node": "Noeud par défaut",
		"default_theme": "Thème par défaut",
		"custom_theme": "Personnalisez votre thème"
	},
	"intro": {
		"sys_msg": "Message du système",
		"gaa_msg": "Alarme et rappel",
		"new_guide": "Guide pour débutants",
		"slider_quite": "Quitter le bootstrap",
		"slider_pre": "Précédent étape précédente",
		"slider_next": "Prochaine étape",
		"slider_enter": "Entrez dans la nouvelle édition",
		"step_project_1": "Devicede gestion pour le nouveau système",
		"step_project_2": "Nouveaux",
		"step_project_3": "GestionProjet",
		"step_project_4": "Fonctions, devices sous-projets à gérer. L'utilisateur peut effectuer sur le projet",
		"step_project_5": "Nouveau, modifier, supprimer",
		"step_mode_1": "Choisissez le style de liste d'appareils que vous préférez",
		"step_mode_2": "La liste des devices est accessible via",
		"step_mode_3": "Liste ou carte",
		"step_mode_4": "Formulaire de présentation, vous choisissez la présentation en fonction de votre situation.",
		"step_device_1": "Trouvez rapidement l'deviceconcerné",
		"step_device_2": "Nouveaux",
		"step_device_3": "Focus sur l'device",
		"step_device_4": "La fonction",
		"step_device_5": "Survolez votre souris",
		"step_device_6": "Lorsque vous êtes sur l'appareil, vous pouvez cliquer sur suivre,",
		"step_device_7": "Après l'attention",
		"step_device_8": "L'deviceest disponible dans ce projet comme",
		"step_device_9": "ZhiDing",
		"step_device_10": ", facile pour vous de trouver l'deviceconcerné.",
		"step_operate_1": "Disposition plus claire des informations sur l'device",
		"step_operate_2": "Après avoir choisi le dispositif que vous voulez connaître, vous pouvez rapidement parcourir le diagramme de flux d'énergie de dispositif, l'information de dispositif, le graphique de données, l'analyse de paramètre, les détails de données, l'information d'alarme."
	},
	"plantCode": {
		"codeApplication": "Demande de code d'expérience",
		"haveDevice": "Si vous avez déjà un appareil, vous pouvez vous inscrire et vous connecter pour l'utiliser",
		"goRegister": "Aller à l'enregistrement",
		"useDemo": "Pas encore de code d'invitation? Le code d'invitation est utilisé uniquement pour la démonstration des fonctionnalités",
		"applyNow": "Postulez dès maintenant",
		"code_is_required": "Le code d'expérience ne peut pas être vide",
		"pleaseCode": "Veuillez entrer le code d'invitation",
		"pleaseName": "Veuillez entrer votre nom",
		"PleaseCompanyName": "Veuillez entrer le nom de l'entreprise",
		"PleaseCompanyAddress": "Veuillez entrer l'adresse de l'entreprise",
		"PleaseNumber": "Veuillez entrer votre numéro de téléphone",
		"PleaseEmail": "Veuillez entrer votre email",
		"PleaseApplication": "Veuillez décrire le motif de votre demande",
		"reasonNotEmpty": "Le motif de la demande ne peut pas être vide",
		"successfulApplication": "Application réussie, s'il vous plaît gardez un oeil sur votre message sur votre téléphone portable ou e-mail, nous vous répondrons dès que possible"
	},
	"retrieveUser": {
		"forgetUser": "Oublier compte",
		"illustrate": "Si vous avez oublié votre numéro de compte, vous pouvez obtenir des conseils pour vous rappeler votre numéro de compte en entrant le numéro PN de n'importe quel appareil sous votre numéro de compte!",
		"pn": "Veuillez entrer le PN de n'importe quel appareil sous le numéro de compte",
		"comfig": "Déterminer",
		"Return_to_login": "Retour au login",
		"accountInfo": "Informations sur le numéro de compte",
		"user": "Votre nom d'utilisateur est",
		"phone": "Le numéro de téléphone mobile auquel votre compte est lié est",
		"email": "La boîte aux lettres à laquelle votre numéro de compte est lié est",
		"pleasePn": "Veuillez entrer le périphérique PN",
		"pnError": "Vous avez entré le pn par erreur",
		"pnErrorMsg": "No number Picker trouvé"
	},
	"login": {
		"login": "Connexion",
		"loginSuc": "Connexion réussie",
		"no_account_yet": "Pas encore de compte?",
		"remember_pwd": "Enregistrer passe",
		"no_invitation": "Pas encore de code d'expérience? Veuillez nous contacter",
		"linkman": "Le soleil ebon",
		"signup": "Inscrivez-vous dès maintenant",
		"usr": "Nom de l'utilisateur",
		"pwd": "Les mots de passe",
		"sample_station": "Présentation",
		"invitation": "Le code expérience",
		"invitationLogin": "Expérience code connexion",
		"forgotPwd": "Mot de passe oublié?",
		"usrformat": "Format du compte (2<= longueur utilisateur <=32) ',",
		"forgotUser": "Oublier compte",
		"pwdformat": "Format du mot de passe (6<= longueur du mot de passe <=32)",
		"YHLogin": "Login pour utilisateurs",
		"Yzcode": "Veuillez entrer le captcha",
		"code": "Faites glisser le curseur inférieur pour compléter le puzzle",
		"Swipe_right": "Glisser vers la droite",
		"scan_login": "Code de balayage login",
		"open": "ouvrir",
		"Scancode_login": "Balayage du débarquement",
		"scanning": "balayage",
		"success": "Le succès",
		"Pleaseconfirm_login": "Veuillez confirmer votre connexion",
		"SmartESS": "Trésor de stockage léger",
		"pv123": "PV123 ESS",
		"X_Tech": "X-Tech",
		"app_download": "Télécharger l'app",
		"scan_download": "Code de balayage mobile télécharger l'application",
		"YZcode_format": "Le format du captcha est incorrect, veuillez entrer les chiffres",
		"no_validitycode": "Le Code d'invitation n'est pas dans la période de validité",
		"auto_login": "Connexion automatique",
	},
	"signup": {
		"login": "Se connecter maintenant",
		"code": "Code de vérification à 6 chiffres",
		"pwd": "6-32 caractères (chiffres, lettres, soulignement), sensible à la casse",
		"confirm_password": "Veuillez entrer le mot de passe à nouveau",
		"phone": "Téléphones portables",
		"phone_form": "32 caractères ou moins. Veuillez le remplir avec précision afin de récupérer votre mot de passe",
		"pn": "14 ou 18 caractères (chiffres, lettres seulement)",
		"usr": "2-32 caractères (seulement le chinois, les lettres et les chiffres peuvent être soulignés) nom du compte",
		"email": "La boîte aux lettres",
		"email_form": "64 caractères ou moins. Veuillez le remplir avec précision afin de récupérer votre mot de passe",
		"existing_account": "Déjà un compte?",
		"Register_account": "Enregistrement du compte",
		"signup": "Enregistrement",
		"emailSignup": "Inscription par email",
		"phoneSignup": "Inscription par téléphone",
		"registered": "Enregistrement",
		"success": "Inscription réussie avec",
		"mobileformat": "Mauvais format du numéro de téléphone (6-32)",
		"mobileformat1": "Veuillez entrer un numéro de téléphone portable correct",
		"emailformat": "Veuillez entrer un email correct",
		"usrformat": "Le format du numéro de compte est incorrect,2-32 (seulement les caractères chinois, les lettres et les chiffres peuvent être soulignés)",
		"pwdformat": "Le format du mot de passe est incorrect, de 6 à 32 (chiffres, lettres, soulignement seulement) '",
		"pnformat": "Numéro PN format incorrect,14 ou 18 chiffres (chiffres, lettres seulement)",
		"qiang": "forte",
		"zhong": "dans",
		"di": "faible",
		"qiangdu": "Force du mot de passe:",
		"Byte_1": "A été entré",
		"Byte_2": "Un caractère",
		"usr_pl": "Nom de l'utilisateur",
		"pwd_pl": "Les mots de passe",
		"confirm_pl": "Veuillez entrer le mot de passe à nouveau",
		"confirm_Pwdpl": "Confirmer le mot de passe",
		"email_pl": "Adresse e-mail adresse",
		"mobile_pl": "Numéro de téléphone",
		"code_pl": "Code de vérification",
		"PN_pl": "La PN",
		"too_simple": "Le mot de passe est trop simple, veuillez le saisir à nouveau",
		"country_pl": "Pays ou région",
	},
	"createPlant": {
		"imageLimit": "Les images sont uniquement au format JPG, PNG et ne doivent pas dépasser 8M maximum",
		"fileExceed": "Fichier trop volumineux",
		"uploadSuccess": "Téléchargé avec succès",
		"basic_settings": "Les réglages essentiels",
		"Standard_setting": "Le set standard",
		"System_settings": "Configuration du système",
		"Solar_settings": "Installation d'énergie solaire",
		"Grid_settings": "Configuration du réseau",
		"Battery_settings": "Réglage de batterie",
		"Battery_settingsTT": "Paramètres généraux de la batterie",
		"Battery_settings1": "Bloc Batterie 1",
		"Battery_settings2": "Bloc Batterie 2",
		"Work_settings2": "Définir l'état de fonctionnement du système",
		"Machine_settings2": "Activer la mise en veille de la machine",
		"Clear_settings2": "Effacer les pannes",
		"Control_settings": "Réglage du stockeur d'énergie",
		"Load_setting": "Réglage de charge",
		"other_settings": "Les autres paramètres",
		"Basic_setting": "Set de fondation",
		"Advanced_setting": "Les paramètres avancés",
		"select_all": "Tout sélectionner",
		"pv": "PV",
		"gd": "Réseau",
		"bt": "Batterie",
		"bc": "Charge",
		"sy": "Système",
		"eg": "Générateur",
		"hl": "ChargeDomestique"
	},
	"Upload": {
		"Upload": "télécharger"
	},
	"menu": {
		"home": "La page de couverture",
		"datalogger": "Gestion des dataloggers de nombres",
		"account": "Utilisateurs",
		"device": "Devices",
		"overview": "AperçuGénéral",
		"alarm": "Alarmes",
		"setting": "Paramètres",
		"personal": "Votre message personnel",
		"basic": "Les informations essentielles",
		"password": "Changement de mot",
		"alarmSetting": "Réglage des alarmes",
		"email": "Configuration de messagerie",
		"mobile": "Paramètres du téléphone",
		"recharge": "Paramètres de recharge",
		"pay": "Recharge du trafic",
		"record": "Enregistrement de recharge",
		"rate": "Réglage des tarifs",
		"customize": "Personnalisez vos paramètres",
		"firmware": "Gestion du firmware",
		"firmwarenew": "Gestion du firmware",
		"adaptiveFirmware": "Micrologiciel Adaptatif",
		"intelligenceUpgrade": "Mise à niveau intelligente",
		"intelligenceUpgradeTitle": "Aucun paquet de mise à jour disponible, veuillez contacter le fabricant",
		"intelligenceUpgradeTitle1": "Veuillez confirmer si l'appareil doit effectuer une mise à niveau intelligente ?",
		"intelligenceUpgradeTitle2": "Aucun paquet de mise à jour correspondant trouvé",
		"Total_user": "Nombre total d'utilisateurs:",
		"myDevice": "Device",
		"strategy": "Stratégie de mise à niveau locale",
		"cloudsUpgrade": "Mise à niveau vers le cloud",
		"functionalApplication": "FonctionsApplication",
		"browseAccount": "Gestion des sous - comptes",

		"log": "Log du compteur",
		"actionLog": "Journal des opérations",
		"Manufacturer": "Gestion des fabricants",
		"datalogger_list": "Liste des récupérateurs de nombres",
		"manufacturer_account": "Numéro de compte du fabricant",
		"manufacturer_code": "Code du fabricant",
		"protocol_binding": "Liaison du Protocole number Picker",
		"type_code": "Codage du type de collecteur de nombres",
		"protocol_change": "Changement de protocole d'extraction de nombres",
		"AIP_Interface": "Interface API",
		"protocol_operation": "Outils de fonctionnement du Protocole",
		"recharge_management": "Gestion des recharges",
		"device_management": "Gestion des équipements",
		"KEY_List": "Liste des key",
		"Protocol_instruction": "Gestion des directives du Protocole",
		"Raw_data": "Analyse des données brutes",
		"Recharge_remedy": "Réparation de recharge",
		"device_function": "Fonctions de gestion des appareils",
		"Password_maintenance": "Contrôle Mot de passe Maintenance",

	},
	"header": {
		"plant_owner": "Propriétaire de centrale",
		"personal_infor": "Votre message personnel",
		"change_password": "Changer votre mot de passe",
		"bind_mobile": "Lier le téléphone",
		"bind_email": "Lier votre boîte mail",
		"language": "Paramètres de langue",
		"log_out": "Quitter le système",
		"skin": "Changement de peau",
		"shopping_mall": "Le centre commercial",
		"operating_manual": "Manuel d'exploitation",
		"pleaseSelect": "Veuillez sélectionner un",
		"pleaseSelect1": "Veuillez sélectionner une heure",
		"pnAndAlias": "PN/Le nom",
		"pnAndSN": "PN / SN"
	},
	"role": {
		"plantOwnerNew": "Pour l'utilisateur ordinaire",
		"plantOwner": "Propriétaire de centrale",
		"manufacturer": "Numéro de compte fabricant",
		"distributor": "distributeur",
		"group": "Numéro de compte groupe",
		"viewer": "Visiteurs de centrales",
		"all": "Tous les"
	},
	"statistic": {
		"All": "Tous les",
		"regiontotal": "Total des régions",
		"deviceStatus": "État des devices",
		"regionPercent": "Part des régions",
		"userActivity": "Taux d'activité des utilisateurs",
		"dataUpdateTime": "Heure de mise à jour des données",
		"normal": "Normale",
		"offline": "Off-line",
		"Allstate": "Tous les états",
		"warning": "Hors ligne",
		"fault": "En panne",
		"standby": "En veille",
		"totalDevice": "Tous vos devices",
		"allDevice": "Total des devices",
		"totalRegion": "Toutes les régions",
		"other": "autres",
		"allAccount": "Tous",
		"generalAccount": "Propriétaire",
		"adminAccount": "Distributeurs",
		"active": "actifs",
		"inactive": "N'est pas actif",
		"pv": "Données des panneaux photovoltaïques",
		"gd": "Données réseau électrique",
		"sy": "Données de l'device",
		"bt": "Données de batterie",
		"bc": "Données de charge"
	},
	"account": {
		"title_pwd": "Veuillez saisir le mot de passe correct",
		"title_pwd1": "Veuillez entrer un mot de passe de 6 à 32 bits",
		"title_pwd2": "Veuillez saisir un nouveau mot de passe",
		"title_mobile": "Veuillez saisir le numéro de téléphone à 11 chiffres",
		"title_edit": "Veuillez entrer les informations que vous devez modifier",
		"title_info": "Veuillez entrer la bonne boîte aux lettres",
		"title_info1": "Veuillez entrer le bon numéro de téléphone portable",
		"allAccount": "Pour tous utilisateurs",
		"userAccount": "Utilisateurs",
		"groupAccount": "Groupe",
		"uselists": "Liste de gestion des utilisateurs",
		"accountManage": "Gestion du compte",
		"groupManage": "Gestion par groupes",
		"activeStatus": "Niveau de l'activité",
		"accountGroup": "Regroupement des utilisateurs",
		"createAccount": "Créer un compte",
		"relatedOwner": "Les propriétaires associés",
		"relatedSuccess": "Associé au succès",
		"adminRelated": "Veuillez sélectionner administrateur",
		"role": "Types d'utilisateurs par",
		"role1": "Type d'utilisateur:",
		"selectUserType": "Veuillez sélectionner un type d'utilisateur",
		"generalAccount": "Numéro de compte ordinaire",
		"manageAccount": "Un compte administrateur",
		"accountName": "Nom de l'utilisateur",
		"accountName1": "Nom de l'utilisateur",
		"accountName2": "Veuillez entrer votre nom d'utilisateur",
		"accountRole": "Le rôle",
		"nickname": "Pseudo de l'utilisateur",
		"nickname1": "Pseudo de l'utilisateur:",
		"password": "Utilisateur mot de passe",
		"password1": "Utilisateur mot de passe:",
		"newPwd": "Nouveau mot de passe",
		"newPwd1": "Nouveau mot de passe:",
		"confirmpassword": "Confirmer le mot de passe",
		"confirmpassword1": "Confirmez votre mot de passe:",
		"createTime": "Temps de création",
		"accountStatus": "Statut de l'utilisateur",
		"dataloggerNum": "Nombre de dataloggers",
		"deviceNum": "Nombre de dispositifs",
		"projectNum": "Nombre de projets",
		"lastLogin": "Dernière connexion disponible",
		"editUser": "Modifier un utilisateur",
		"editAccount": "Modifier le compte",
		"group": "Le sous-groupe",
		"group1": "Regroupés par:",
		"groupto": "Regrouper à",
		"changeGroup": "Déplacer le groupe vers",
		"chooseGroup": "Veuillez sélectionner un groupe",
		"changeGroupSuc": "Succès du regroupement mobile",
		"defaultGroup": "Groupes par défaut",
		"enable": "LeLancement",
		"disable": "Interdits",
		"confirmDisable": "Est sûr de désactiver cet utilisateur",
		"afterDisable": "Après la désactivation, le compte ne pourra pas se connecter et ne pourra pas voir ou modifier le contenu associé au compte",
		"disableSuc": "Désactivé avec succès",
		"confirmEnable": "Est sûr d'activer cet utilisateur",
		"deleteUser": "Supprimer un compte",
		"afterEnable": "Une fois activé, ce compte peut rétablir la connexion pour voir ou modifier le contenu associé à ce compte",
		"confirmDelete": "Est sûr de supprimer",
		"notRecovered": "Ne peut pas être récupéré après suppression",
		"deleteSuc": "Supprimé avec succès",
		"resetPwd": "Réinitialiser votre mot de passe",
		"allTypeUser": "Tous types d'utilisateurs",
		"powerStationOwner": "Propriétaire de centrale",
		"powerStationViewer": "Visiteurs de centrales",
		"admin": "administrateur",
		"riyueyuan_lineSonAdmin": "Sous Administrateur de ligne de production",
		"riyueyuan_SonAdmin": "Sous Administrateur",
		"nodata": "Données non disponibles",
		"reason": "Les raisons de ne pas afficher les graphiques peuvent être:",
		"reason1": "Devicenon disponible",
		"reason2": "Protocole d'deviceaucun champ de paramètre pour la production d'électricité, consommation d'électricité, achat d'électricité, vente d'électricité, quantité de charge, décharge de puissance",
		"reason3": "Protocole d'devicechamps de paramètres sans puissance générée, puissance de charge, puissance de batterie, puissance du réseau",
		"createSuc": "Créer un compte avec succès",
		"resetPwdSuc": "Réinitialiser le mot de passe avec succès",
		"allGroup": "Tous les groupes",
		"unclassified": "Non regroupés",
		"cannotRedirect": "Ce compte n'est pas un compte de stockage d'énergie et ne peut pas sauter",
		"newPwdEmpty": "Le nouveau mot de passe ne peut pas être vide, veuillez le remplir!",
		"accountList": "Liste des comptes",
		"mobile": "Téléphones portables",
		"mobile1": "Téléphone portable:",
		"email": "La boîte aux lettres",
		"email1": "Adresse mail:",
		"modifiedsuccess": "Les informations de l'utilisateur ont été modifiées avec succès!",
		"enablesuccess": "Activé avec succès!",
		"disablesuccess": "Désactiver avec succès!",
		"groupsuccess": "Opération groupée réussie!",
		"pwdresetsuccess": "Mot de passe réinitialisé avec succès!",
		"Deletesuccessfully": "Compte supprimé avec succès!",
		"plantOwner": "Propriétaire de centrale",
		"distributor": "distributeur",
		"operate": "opérations",
		"Edit": "Rédacteur en chef",
		"Delete": "supprimé",
		"binding": "Codes 02109020",
		"ascription": "Pulau batu puteh",
		"ascriptionSuccess": "Succès d'attribution",
		"ascription_result": "Résultats d'attribution",
		"cancel": "Annulation",
		"finish": "L'achèvement du",
		"confirm": "déterminer",
		"submit": "Présenté par le",
		"deletegroupsuccess": "Retiré du groupe avec succès!",
		"deletegroup": "Retrait du groupe",
		"currentTotal": "Total actuel total",
		"projects": "Article article article",
		"searchPro": "Rechercher un projet",
		"devices": "Equipement de table",
		"accounts": "Pour un utilisateur",
		"placeholder": "Recherche par nom d'utilisateur/numéro de téléphone portable",
		"placeholder1": "Veuillez entrer votre nom d'utilisateur/numéro de téléphone portable",
		"lastLoginTs": "Dernière heure de connexion",
		"enterHome": "Aller à homepage",
		"ownedDevices": "Posséder un device",
		"Distribution_collector": "Distribution des dataloggers",
		"tooltipContent": "L'administrateur peut attribuer tous les dataloggers de nombres placés dans une commande à un revendeur inférieur par numéro de commande",
		"Distribution_method": "Mode de distribution",
		"Batch_allocation": "Distribution par lots",
		"Individual_allocation": "Une distribution individuelle",
		"Order_allocation": "Répartition des commandes",
		"PNNum": "La PN",
		"order_number": "Numéro de commande",
		"Allocation_result": "Répartition des résultats",
		"Assigned_successfully": "Succès de distribution",
		"order_check": "Rapprochement des",
		"Confirm_assignment": "Confirmer l'attribution à",
		"IsIt": "?",
		"limitFormat": "Seuls les fichiers aux formats \"XLSX\" et \"XLS\" peuvent être téléchargés",
		"Ple_orderNum1": "Veuillez entrer le numéro de commande correct",
		"Ple_orderNum2": "La commande a été placée",
		"Ple_orderNum3": "Un datalogger, confirmant l'attribution à",
		"err_orderNum": "Disponible dans l'ordre",
		"err_orderNum1": "Un datalogger est lié, veuillez vérifier que le datalogger de la commande n'est pas lié",
		"Ple_orderNum": "Veuillez entrer le numéro de commande",
		"dataogger_swith": "Ajouter un collecteur de nombres",
		"dataogger_swithTip": "Le numéro de compte peut - il avoir l'autorisation d'ajouter un collecteur de nombres?",
		"account_number": "Numéro de compte",
		"Role_authority": "Permissions",
		"authority_Management": "Gestion des droits",
		"Related_roles": "Rôles associés",
		"Ple_role1": "Veuillez sélectionner un rôle associé",
		"Ple_role2": "Veuillez entrer le nom / ID du rôle",
		"Add_role": "Ajouter un rôle",
		"Edit_role": "Modifier le rôle",
		"Role_id": "ID du rôle",
		"Role_name": "Nom du rôle",
		"Ple_role3": "Veuillez entrer un nom de rôle",
		"Role_des": "Description du rôle",
		"Ple_role4": "Veuillez entrer une description de rôle",
		"module": "Modules",
		"First_page": "La page",
		"Secondary_page": "Pages de deuxième niveau",
		"Function_points": "Fonctions",
		"Remove_role": "Supprimer un rôle",
		"Ple_role5": "Veuillez cocher le numéro de compte permissions",
		"No_permission_prompt": "Aucune autorisation, veuillez contacter l'administrateur supérieur",
		"Ple_role6": "Le nom du rôle existe déjà, veuillez le saisir à nouveau",
		"limit_UserTypeNum": "Au - delà de la limite, ce type de compte existe déjà",
		"limit_UserTypeDataPermission": "Les comptes de concessionnaires ne peuvent pas associer des rôles avec des autorisations de données sélectionnées.",
		"edit_limit_UserTypeDataPermission": "Le rôle est associé à un compte concessionnaire et les autorisations de données ne peuvent pas être modifiées.",
		"dataPermission": "Autorisation de données",
		"functionalPermission": "Autorisation fonctionnelle"
	},
	"group": {
		"Create_groups": "Créer un groupe",
		"Edit_groups": "Éditer les groupes",
		"Groups_list": "Liste des groupes",
		"Group_name": "Nom du groupe",
		"Group_name1": "Nom du groupe:",
		"userCount": "Nombre d'utilisateurs groupés",
		"note": "Remarques des groupes",
		"note1": "Remarques du groupe:",
		"Operate": "opérations",
		"Delete": "supprimé",
		"cancel": "Annulation",
		"finish": "L'achèvement du",
		"confirm": "La confirmation",
		"deletegroup": "Supprimer",
		"deleteConfirm": "Sûr de vouloir supprimer ce groupe?",
		"entername": "Veuillez entrer le nom du groupe",
		"deletesuc": "Supprimer le groupe avec succès",
		"creatsuc": "Créer un groupe réussi",
		"editsuc": "Succès du regroupement rédactionnel"
	},
	"device": {
		"set": "Paramètres",
		"ownerShip": "Changement de propriétaire",
    "oldOwner": "Ancien propriétaire :",
    "nweOwner": "Nouveau propriétaire :",
    "loading": "Chargement...",
    "moreLoading": "Faire défiler pour charger plus",
		"pleaseDate": "Veuillez sélectionner une date",
		"noDate": "Aucune date future ne peut être sélectionnée",
		"deviceDebug": "Mise en service de l'device",
		"upgradeType": "Méthode de mise à niveau:",
		"defaultUpgrade": "Mise à niveau par défaut",
		"cloudUpgrade": "Mise à niveau vers le cloud",
		"continueUpgrade": "Continuer la mise à niveau",
		"continueUpgradeSuccess": "Continuer la mise à niveau ajouter avec succès",
		"step": "Étapes pour commencer:",
		"firmware_step_message": "Veuillez entrer les étapes de démarrage",
		"numberRlues": "Veuillez entrer le nombre correct d'étapes",
		"firmware_package_message": "Veuillez sélectionner le firmware",
		"firmware_type_message": "Veuillez sélectionner le type",
		"baudrate_message": "Veuillez sélectionner Baud rate",
		"device_continueUpgrade": "L'devicecontinue à mettre à niveau",
		"read": "Lire",
		"distribute": "Posté en bas",
		"optionTitle": "Sélectionné",
		"optionTitle1": "Items",
		"optionTitle2": "La sélection des paramètres de l'appareil ne peut pas dépasser 4",
		"optionTitle4": "La sélection des paramètres de l'appareil ne peut pas dépasser 12",
		"optionTitle3": "Veuillez ne pas sélectionner plus de 2 unités différentes",
		"upBatchDeviceTip": "Remarque: la mise à niveau par lots est donnée à plusieurs appareils pour mettre à niveau le même firmware de l'appareil. Si vous n'êtes pas clair sur le firmware auquel l'appareil correspond, veuillez choisir soigneusement!",
		"upSuccessDevice": "Mise à niveau des devices réussis",
		"upFailDevice": "Mise à niveau des appareils défaillants",
		"brandDevice": "devices",
		"brand0": "Autre machine de stockage d'énergie",
		"brand1": "Inverseur hors réseau",
		"brand2": "Inverseur et inverseur",
		"brand3": "Stockage d'énergie tout-en-un",
		"Allthemachines": "Tous vos devices",
		"deviceList": "Device Liste",
		"device": "Device",
		"datalogger": "Datalogger",
		"dataloggerList": "Datalogger Liste",
		"followList": "Focus sur l'device",
		"proList": "Projets Liste",
		"pro": "Projets",
		"deviceName": "Nom de l'appareil",
		"dataview": "Paramètres temps réel",
		"dataTips": "L'appareil est actuellement hors ligne, pas de données en temps réel.",
		"overview": "Statistiques en bref",
		"chart": "Graphique des données",
		"analysis": "Analyse des paramètres",
		"clause": "Détail des données",
		"Current_data": "Les données actuelles",
		"chosenParam": "Les paramètres sélectionnés",
		"optionalParam": "Les paramètres facultatifs",
		"reset": "La valeur de remplacement",
		"energyFlow": "Diagramme des flux d'énergie",
		"device_name": "Nom de l'appareil",
		"device_pn": "La PN",
		"device_sn": "Equipement nt",
		"device_status": "État des devices",
		"device_upgrade1": "Dernière mise à jour enregistrée",
		"device_upgradeFirmware": "Choisissez un paquet de firmware pour mettre à niveau votre appareil",
		"device_upgradeTime": "Temps de mise à niveau",
		"device_upgradeName": "Nom du firmware mis à jour",
		"device_upgradeStatus": "Statut de mise à niveau",
		"device_upgradeProgress": "Progression des mises à niveau",
		"device_type": "Type de matériel",
		"device_code": "Protocole de communication",
		"device_code_form": "Protocole de communication:",
		"device_model": "Modèle de matériel",
		"User_belong": "Un utilisateur affilié",
		"field": "Contrôle des champs",
		"Datalogger_belong": "Nombre d'affiliation datalogger",
		"detail": "Voir les détails",
		"pageSize": "Quand la page s'affiche",
		"follow": "Une attention",
		"unfollow": "Se désabonner",
		"report": "Les états",
		"timeSlot": "Période de temps",
		"datalogger_pn": "datalogger de nombres PN",
		"coll_alias": "Nombre extracteur alias",
		"device_address": "Adresse de l'device",
		"generation": "Panneaux photovoltaïques",
		"grid": "Le réseau",
		"inverter": "Inverseur et inverseur",
		"battery": "Les piles",
		"consumption": "La charge",
		"relay": "Légèrement inversé",
		"alternator": "Générateur électrique",
		"familyLoad": "Charge domestique",
		"solar": "Solaire",
		"cur_today": "Aujourd'hui",
		"cur_thismonth": "Ce mois-ci,",
		"cur_thisyear": "Cette année,",
		"cur_day": "Jour",
		"cur_month": "Mois",
		"cur_year": "Année",
		"day": "Puissance temps réel",
		"month": "Electricité du mois",
		"year": "Electricité année",
		"all": "Puissance électrique totale",
		"pvPower": "Puissance générée",
		"gridPower": "Puissance du réseau",
		"batteryPower": "Puissance de batterie",
		"loadPower": "Puissance de charge",
		"generated": "Production d'énergie électrique",
		"charged": "Quantité de charge",
		"discharged": "Mettre de l'électricité",
		"sold": "Électricité à vendre",
		"bought": "Acheter de l'électricité",
		"used": "Consommation d'électricité",
		"normal": "Normale",
		"offline": "Off-line",
		"warning": "Hors ligne",
		"fault": "En panne",
		"standby": "En veille",
		"universal_firmware": "Le firmware universel",
		"communication_firmware": "Version de communication firmware",
		"control_firmware1": "Contrôle du firmware 1",
		"control_firmware2": "Contrôle du firmware 2",
		"control_firmware_bms": "Firmware pour BMS",
		"control_firmware_slavmcu": "Firmware pour SlavMCU",
		"default": "Par défaut",
		"modifySuc": "Modifié avec succès",
		"instruction_response": "Instructions en cours d'envoi, en attente de réponse...",
		"debug_suc": "Succès de mise en service",
		"Debugfail": "Le débogage a échoué et l'appareil est hors ligne",
		"Send_suc": "Ordre envoyé avec succès",
		"Send_Input": "Veuillez entrer la valeur de l'opération que vous souhaitez envoyer",
		"Send_fail": "Échec de l'envoi des ordres",
		"fileExceed": "Fichier trop volumineux",
		"uploadSuccess": "Téléchargé avec succès",
		"error1": "Seuls les fichiers aux formats \".bin\" et \".hex\" peuvent être téléchargés",
		"file_fist": "Veuillez d'abord sélectionner le firmware que vous souhaitez mettre à jour",
		"updatefail": "La mise à niveau échoue, le datalogger peut être hors ligne ou vérifier si la communication avec le datalogger est correcte",
		"update_suc": "Mise à niveau réussie",
		"deleteSuc": "Supprimé avec succès",
		"Operation": "opérations",
		"edit": "Rédacteur en chef",
		"debug": "La mise en service",
		"upgrade": "Mise à niveau par lots",
		"upgrade1": "l'escalade",
		"more": "Plus d'actions",
		"one_click_read": "Lire en un clic",
		"cloudsUpgrade": "Mise à niveau vers le cloud",
		"queryUpgrade": "Enquête de masse sur la progression de la mise à niveau",
		"control": "Le contrôle",
		"delete": "supprimé",
		"modify_alias": "Editez votre device",
		"serial_number": "SN matériel:",
		"device_alias": "Nom de l'appareil:",
		"cancel": "Annulation",
		"confirm": "déterminer",
		"Device_sn": "Numéro de série",
		"Device_pn": "Equipement PN",
		"Instruction": "Les instructions:",
		"such_as": "Ex AA BB CC DD EE FF",
		"return_content": "Retour au contenu:",
		"send": "Envoyer une instruction",
		"clear_data": "Effacer vos données",
		"clear_val": "l'enlèvement",
		"copy_val": "La reproduction",
		"copy_val_yes": "Copiez avec succès",
		"copy_val_no": "La copie échoue",
		"Field_Name": "Nom du champ",
		"Unit": "Les unités",
		"current_val": "La valeur actuelle",
		"Battery_voltage": "Tension des accumulateurs",
		"Magnification": "PST",
		"Send_Command": "Les instructions sont envoyées",
		"device_upgrade": "Mise à niveau du firmware de l'appareil",
		"device_cloudsUpgrade": "Mise à niveau de l'équipement Cloud",
		"select_firmware": "Le firmware:",
		"select_file": "Veuillez sélectionner le firmware",
		"firmware_type": "Type de firmware:",
		"select_type": "Veuillez sélectionner un type de firmware",
		"upgrade_brate": "Taux de baud:",
		"select_brate": "Veuillez sélectionner baud rate",
		"Upload": "Télécharger le firmware",
		"Upload1": "Télécharger un nouveau firmware",
		"confirm_deldte": "Confirmer la suppression?",
		"deleteDevice": "Supprimer un appareil",
		"Today_income": "Gains de production d'électricité de la journée",
		"Cumulative_income": "Bénéfice total de la production d'électricité",
		"sellProfit_Today": "Revenus de la vente d'électricité le jour même",
		"sellProfit_Total": "Revenu total de la vente d'électricité",
		"buyProfit_Today": "Dépenses d'achat d'électricité le jour même",
		"buyProfit_Total": "Dépenses totales d'achat d'électricité",
		"noAuth": "Aucun utilisateur affilié, aucun droit de voir",
		"statistic": "statistiques",
		"protocolStatistic": "Statistiques sur les protocoles de communication",
		"chooseProtocol": "Choisissez un protocole:",
		"parameter": "Les paramètres",
		"value": "Les valeurs",
		"Upgrading": "Mise à jour en cours, veuillez patienter",
		"System_Failed": "Le système ne démarre pas le processus de mise à niveau de l'appareil en raison d'une communication anormale ou d'autres raisons",
		"Device_Offline": "L'appareil ou le datalogger de nombres est hors ligne",
		"In_Upgrading": "Deviceou datalogger de nombres déjà en cours de mise à niveau",
		"Update_Completed": "Mise à niveau terminée",
		"Voltage": "La tension",
		"Electric": "courant",
		"power": "puissance",
		"frequency": "La fréquence",
		"Input_form": "Entrez le tableau",
		"add": "Une augmentation",
		"Output_table": "Tableau des sorties",
		"Please_parameter": "Veuillez sélectionner un paramètre",
		"Successfully_modified": "Modifié avec succès",
		"edit_control": "Permissions Device",
		"Equipment_agreement": "Protocole des devices",
		"Check_all": "Tout cocher",
		"Cancel_all": "Annuler tout annuler",
		"administrator_cansee": "Représentants des droits sélectionnés: visible pour l'administrateur, non sélectionné pour invisible.",
		"person_cansee": "Représentants des droits sélectionnés: visible pour le propriétaire, invisible pour ceux qui ne sont pas sélectionnés.",
		"admin_authority": "Droits de l'administrateur",
		"person_authority": "Droits du propriétaire",
		"noDataPlease": "Aucune donnée disponible. Veuillez sélectionner f à nouveau pour choisir l'heure",
		"Sn_deviceName": "SN / Nom du périphérique / PN / Utilisateur",
		"deviceInfo": "Informations sur l'device",
		"alarmInfo": "Informations sur l'alarme",
		"deviceNo": "Vous n'avez pas encore ajouté d'appareil",
		"showParam": "Afficher les paramètres",
		"selecParameters": "Les paramètres ont été sélectionnés",
		"refresh": "Mise à jour",
		"obtain": "L'accès à",
		"moveResults": "Déplacer les résultats",
		"moveSuc": "Le succès mobile",
		"maxSelect": "Vous ne pouvez cocher que 7 paramètres maximum",
		"minSelect": "Au moins 1 paramètre doit être coché",
		"loadMore": "Charger plus...",
		"upDevice": "Amélioration des device",
		"addUpgrade": "Ajouter une tâche de mise à niveau",
		"upgradeProgress": "Progression actuelle de la mise à niveau",
		"deviceUpgradeProgress": "Progression de la mise à niveau de l'device",
		"addUpgradeSuccess": "Ajouté avec succès",
				"unbind_tips": "L'appareil n'est pas lié à un propriétaire, veuillez d'abord lier le propriétaire",
		"device_code1": "Code de l'appareil"
	},
	"alarm": {
		"device_Warning": "Alarme de l'appareil",
		"device_Error": "Erreur de l'device",
		"device_Fault": "Défaillance de l'device",
		"Alarm_Event": "Un événement d'alarme",
		"Today_Alarm": "Nombre d'alarmes aujourd'hui",
		"Alarm_Type": "Type d'alarme disponible",
		"Device_Type": "Type de matériel",
		"Alarm_Status": "Statut du traitement",
		"Alarm_List": "Liste des alarmes",
		"deletes": "supprimé",
		"tips": "rappel",
		"details": "Détails",
		"alarmDetails": "Détails de l'alarme",
		"alarmInfo": "Situation d'alarme",
		"alarmDevice": "Informations sur l'équipement",
		"delete_alarm": "Sûr de vouloir supprimer cette alarme?",
		"Cancel": "Annulation",
		"Confirm": "La confirmation",
		"Close": "Fermé",
		"processed": "A été traité",
		"untreated": "Non traité",
		"allAlarm": "Nombre total d'événements d'alarme",
		"alarmStatus": "Statistiques d'état de traitement des alarmes",
		"warningTitle": "Nombre d'alarmes pour les 7 derniers jours",
		"faultTitle": "Nombre de défaillances au cours des 7 derniers jours",
		"alarmNum": "Nombre d'alarmes",
		"faultNum": "Nombre de défauts",
		"all": "Pour tous",
		"warning": "témoin",
		"error": "Les erreurs",
		"fault": "En panne",
		"offline": "Off-line",
		"inverter": "Inverseur et inverseur",
		"monitor": "Détecteur de l'environnement",
		"smart_meters": "Compteur électrique intelligent",
		"combining_manifolds": "Boîte de convergence",
		"Camera": "caméra",
		"Battery": "Les piles",
		"Charger": "chargeur",
		"storage": "Machine de stockage d'énergie",
		"Prevent_arcing_island": "Dispositif anti-île",
		"Microinverter": "Le micro inverter",
		"Occurrence_time": "Heure de l'événement",
		"endtime": "Temps de fin",
		"Device_Name": "Nom de l'appareil",
		"Device_PN": "Nombre datalogger PN no.",
		"Plant": "Centrale électrique affiliée",
		"Alarm_Code": "Codage des alarmes",
		"Alarm_Describe": "Description de l'alarme",
		"Device_SN": "Equipement nt",
		"device_alias": "Alias de l'appareil",
		"device_address": "Adresse de l'device",
		"User": "Un utilisateur affilié",
		"Status": "l'état",
		"Operation": "opérations",
		"Delete_selected": "Supprimer la sélection",
		"deleted_successfully": "Alarme supprimée avec succès!",
		"Alarm_Msg": "Un nouveau message",
		"Intro_Msg": "Guide pour débutants",
		"Alarm_Read": "Vous avez lu toutes les notifications d'alarme",
		"Alarm_data": "Aucune mise à jour pour le moment oops!",
		"Alarm_Message": "votre",
		"Alarm_Message1": "Apparition de l'device",
		"curSelected": "Actuellement sélectionné pour",
		"_Data": "Barre de données",
		"more": "Davantage de",
		"ruleManage": "Gestion des règles de filtrage des alarmes",
		"ruleNew": "Nouvelles règles ajoutées",
		"ruleName": "Nom des règles",
		"timeSlot": "Période de temps",
		"deviceType": "Type de matériel",
		"deviceFilter": "Devicede filtration",
		"alrmType": "Filtrer les types d'alarmes",
		"alrmDes": "Description des alarmes filtrées",
		"filterHistory": "Filtrer l'histoire",
		"clearHistory": "Effacer votre histoire",
		"view": "Voir",
		"back": "Retour",
		"exportArchive": "Exporter l'alarme archivée",
		"archiveRecord": "Archives",
		"archiveTip": "La liste comprend toutes les alarmes non traitées et les enregistrements traités dans les 7 jours"
	},
	"datalogger": {
		"activeStatus": "État d'activation",
		"Active": "Activé",
		"notActive": "Non activé",
		"timeZone": "Fuseau horaire",
		"please_title": "Veuillez entrer 'YES' pour confirmer le retour à l'état d'usine",
		"frequency": "fréquence d'acquisition",
		"heartbeat": "battement de coeur",
		"warehousing_time": "heure d'entrée dans le stock",
		"start_address": "adresse de début du sondage",
		"deadline_address": "adresse de coupure de sondage",
		"title_usr": "Ce compteur n'a pas d'utilisateur affilié",
		"datalogger_log": "Journal",
		"min_addr": "adresse minimale",
		"max_addr": "adresse maximale",
		"transmission": "identité de transmission pure",
		"transparent_set": "collection de protocoles de transmission pure",
		"devcode": "Code du fabricant de l'équipement",
		"protocol_code": "codage du fabricant du Protocole",
		"domain_name": "nom de domaine en ligne",
		"transmission1": "mode d'acquisition local",
		"transmission2": "mode de transmission pure",
		"noDate": "Veuillez sélectionner une date dans les 3 jours",
		"paramSetting": "Paramètres",
		"paramName": "nom du paramètre",
		"paramPar": "numéro de paramètre",
		"paramVal": "valeur du paramètre",
		"dataloggerView": "détails du compteur",
		"describe": "description",
		"field_name": "nom du champ",
		"checkVal": "valeur numérique",
		"resetTitle1": "Êtes - vous sûr de réinitialiser le collecteur de nombres? (1: le rendre réinscriptible, 2: effacer les périphériques subordonnés, 3: supprimer toutes les données sous le collecteur)",
		"unbingTitle": "est - ce que je suis sûr d'avoir désengagé le collecteur de nombres? (1: l'Administrateur revendeur qui l'a désengagé; 2: reconnecter, connectez - vous à l'Administrateur revendeur approprié pour ajouter le collecteur de nombres)",
		"getTitle": "paramètre get",
		"postTitle": "Paramètres",
		"debugeTitle": "définir le débogage",
		"getName": "paramètre get (decimal)",
		"postName": "numéro de paramètre (décimal)",
		"debugeName": "commande：",
		"getVal": "valeur actuelle:",
		"postVal": "définir la valeur:",
		"debugeVal": "Résultat:",
		"debugeAddr": "adresse du périphérique:",
		"getSucc": "obtenir le succès",
		"postSucc": "configuration réussie",
		"debugeSucc": "succès de lancement",
		"copyVal": "copier la valeur",
		"huoqu": "obtenir",
		"shezhi": "Paramètres",
		"xiafa": "ordre de sortie",
		"copy": "Copiez avec succès",
		"flowCard": "Carte valide non recherchée",
		"province": "Province/état",
		"city": "La ville de la ville",
		"county": "Comté/région",
		"country": "Les pays",
		"Flowcard_status": "Statut de carte de trafic",
		"GPRS_traffic": "Trafic par GPRS",
		"upBatchDataloggerTip": "Remarque: la mise à niveau par lots est donnée à plusieurs dataloggers de nombres pour mettre à niveau le même firmware de datalogger de nombres. Si vous ne savez pas clairement quel firmware convient à datalogger de nombres, veuillez choisir soigneusement!",
		"upSuccessDatalogger": "Mise à niveau d'un datalogger de nombres réussi",
		"upFailDatalogger": "Mise à niveau d'un datalogger de nombres défaillant",
		"Datalogger_Status": "État des dataloggers de nombres",
		"com_method": "Mode de communication",
		"Datalogger_PN": "Nombre datalogger PN no.",
		"Datalogger_List": "Datalogger Liste",
		"Datalogger_Name": "Nombre datalogger nom",
		"Ple_PN": "Veuillez entrer le nombre de datalogger PN",
		"Ple_Alias": "Veuillez entrer le nom de l'extracteur de nombres",
		"Datalogger_type": "Type de datalogger de nombres",
		"Datalogger_model": "Les modèles",
		"Datalogger_method": "Mode de communication",
		"Status": "l'état",
		"usr_belong": "Un utilisateur affilié",
		"administrator": "Administrateur affilié à",
		"Communication_balance": "Balance des frais de communication",
		"load": "Nombre avec charge",
		"Firmware_Version": "Version du firmware",
		"signal": "Des signaux",
		"Operation": "opérations",
		"edit": "Rédacteur en chef",
		"reboot": "La reprise",
		"unbind": "Le déliement",
		"more": "Davantage de",
		"resetData": "Réinitialiser vos données",
		"unbindUsr": "Délier le propriétaire",
		"debug": "La mise en service",
		"upgrade": "l'escalade",
		"delete": "supprimé",
		"deleteTitle": "Supprimer le datalogger de nombres",
		"reset": "La valeur de remplacement",
		"resetCode": "Veuillez confirmer en tapant oui",
		"modify_datalog": "Modification des informations sur les dataloggers de nombres",
		"cancel": "Annulation",
		"confirm": "déterminer",
		"datalogger_debug": "Débogage des dataloggers numériques",
		"communication_address": "Adresse postale:",
		"Instruction": "Les instructions:",
		"such_as": "Ex AA BB CC DD EE FF",
		"return_content": "Retour au contenu:",
		"send": "Envoyer une instruction",
		"check": "Vérification",
		"InstructionType": "Format d'instruction",
		"endMarker": "Marqueur de fin",
		"noMarker": "Sans marqueur de fin",
		"noCheck": "Sans vérification",
		"InstructionIssue": "Émettre une instruction",
		"Insufficient": "Nombre insuffisant",
		"clear_data": "Effacer vos données",
		"device_upgrade": "Mise à niveau du firmware de l'appareil",
		"select_firmware": "Le firmware:",
		"select_file": "Veuillez sélectionner le firmware",
		"Upload": "Télécharger le firmware",
		"prompt_message": "Informations sur prompt",
		"confirm_deldte": "Après la suppression de cut-catcher, vous ne serez pas autorisé à gérer toutes les données relatives à cut-catcher",
		"Normal": "Normale",
		"Online": "En ligne",
		"Offline": "Off-line",
		"Normal1": "Statut en ligne",
		"Offline1": "État hors ligne",
		"Allstate": "Allstate",
		"modifySuc": "Modifié avec succès",
		"resetSuc": "Réinitialiser avec succès",
		"unbindSuc": "Dénouage réussi",
		"devaddrfail": "L'adresse postale ne peut pas être vide",
		"Debugfail": "Le débogage a échoué et l'extracteur de nombres est hors ligne",
		"instruction_response": "Instructions en cours d'envoi, en attente de réponse...",
		"fileExceed": "Fichier trop volumineux",
		"uploadSuccess": "Téléchargé avec succès",
		"error1": "Seuls les fichiers aux formats \".bin\" et \".hex\" peuvent être téléchargés",
		"file_fist": "Veuillez d'abord sélectionner le firmware que vous souhaitez mettre à jour",
		"updatefail": "La mise à niveau échoue, le datalogger peut être hors ligne ou vérifier si la communication avec le datalogger est correcte",
		"update_suc": "Mise à niveau réussie",
		"deleteSuc": "Supprimé avec succès",
		"debug_suc": "Succès de mise en service",
		"create": "La création de",
		"addSuc": "Ajout du datalogger de nombres avec succès",
		"add": "Ajouter un appareil",
		"addScq": "Ajouter datalogger",
		"batchAddScq": "Lot d'ajout",
		"editDatalogger": "datalogger de nombres de modification",
		"editDataloggerName": "Édition de l'extracteur numérique",
		"resetDataloggerName": "Réinitialisation du nombre extracteur",
		"unbindDataloggerName": "Dénouer le datalogger de nombres",
		"resetDataloggerExplain": "Cette fonction est principalement pratique pour les fabricants de vider les données de test sur le nuage de l'appareil. Les données historiques de cet appareil seront vidées après la réinitialisation de l'extracteur de nombres. Une fois l'opération effectuée, les données historiques de l'appareil ne peuvent pas être récupérées. Veuillez faire attention!",
		"unbindDataloggerExplain": "Cette fonction est principalement pour faciliter le fabricant à la fin du test avant l'expédition, le compte de test (propriétaire affilié) et le datalogger de numération délier la relation, s'il vous plaît utiliser cette fonction avec prudence, une fois l'opération, le client doit relier à nouveau le datalogger de numération.",
		"rebootDataloggerName": "Redémarrage de l'extracteur numérique",
		"rebootDataloggerSuc": "datalogger de nombres redémarré avec succès",
		"fixOnRebootDataloggerName": "Confirmez le redémarrage de l'extracteur de nombres:",
		"fixOnRebootDataloggerName1": "?",
		"unbindTitle": "Veuillez saisir «oui» pour confirmer que vous souhaitez délier l'extracteur de numération du propriétaire actuel du terminal.",
		"resetTitle": "Confirmez que vous souhaitez réinitialiser l'extracteur de nombres en tapant \"oui\".",
		"editSuc": "datalogger de nombres de modification réussi",
		"basic_info": "Les informations essentielles",
		"datalogger_pn": "Nombre datalogger PN:",
		"datalogger_name": "Nom de l'extracteur de nombres:",
		"nominalPower": "Puissance nominale puissance",
		"install_date": "Temps de montage",
		"installer": "l'installateur",
		"location_info": "Informations sur l'emplacement",
		"location_info1": "Les informations géographiques",
		"district": "Zone administrative urbaine",
		"address": "Position de l'extracteur numérique",
		"dataloggerAddress": "Une adresse complète",
		"enterPosition": "Entrée nombre datalogger position",
		"longi_lati": "Latitude et longitude",
		"latitude": "latitude",
		"longitude": "longitude",
		"currentAddress": "Adresse actuelle:",
		"timezone": "Fuseaux horaires",
		"timezone1": "Votre fuseau horaire",
		"cp1": "Veuillez choisir une date d'installation",
		"cp2": "Veuillez sélectionner un fuseau horaire",
		"cp3": "Veuillez entrer la puissance nominale",
		"cp4": "Veuillez sélectionner la devise de gain",
		"cp5": "Veuillez entrer le nom de l'appareil",
		"cp6": "Veuillez sélectionner un projet affilié",
		"cp7": "Veuillez sélectionner Longitude Latitude",
		"lonRange": "Nombres de longitude allant de - 180 à 180",
		"latRange": "Nombres dans la gamme de latitude - 90 à 90",
		"cp9": "Veuillez entrer votre adresse actuelle",
		"cp10": "Veuillez entrer le nom du projet",
		"income_info": "Informations sur gains",
		"currency": "Devise des gains:",
		"buyProfit": "Acheter le prix de l'électricité:",
		"sellProfit": "Prix de l'électricité vendue:",
		"unitProfit": "Prix de l'électricité consommée:",
		"generateProfit": "Prix de l'électricité produite:",
		"noNegative": "Veuillez entrer un nombre non négatif",
		"buyProfitNew": "Acheter le prix de l'électricité",
		"sellProfitNew": "Prix de l'électricité",
		"generateProfitNew": "Prix de l'électricité produite",
		"add_datalogger": "Nouveau datalogger de nombres",
		"add_suc": "Ajouté avec succès",
		"basicInfo": "Les informations essentielles",
		"connectionInfo": "Informations de connexion",
		"finishAdding": "Complétez votre ajout",
		"addResults": "Ajouter vos résultats",
		"addedSuccessfully": "Ajouté avec succès",
		"finish": "L'achèvement du",
		"continueAdding": "Continuer à ajouter",
		"nowNoAdd": "Pas encore ajouté",
		"reAdd": "Ajouter à nouveau",
		"editResults": "Modifier le résultat",
		"resetResults": "Réinitialiser les résultats",
		"unbindResults": "Résultats du déblocage",
		"delResults": "Supprimer le résultat",
		"locationTip": "Conseils chauds: vous pouvez entrer manuellement quand la position est interdite ou échoue",
		"upDatalogger": "datalogger de nombres amélioré",
		"dataloggerTipName": "datalogger a été ajouté ajouter une personne",
				"batch_edit_datalogger": "Modifier les dataloggers par lot",
				"upload_column_tips": "Rappel : Colonne A est le PN du datalogger, Colonne B est le nombre de charges, Colonne C est le débit en bauds, Colonne D est le protocole de communication, Colonne E est le code du fabricant de l'appareil, Colonne F est le code du fabricant du protocole, Colonne G est le mode de collecte, Colonne H est l'adresse min, Colonne I est l'adresse max, pas de titre requis, voir l'image suivante",
				"upload_csv_tips": "Rappel : Le format du fichier doit être csv, voir l'image suivante pour le contenu",
				"click_enlarge": "Cliquez pour agrandir les détails",
						"collector_expire_time": "Date d'expiration du collecteur",
						"collection_cycle": "Cycle de collecte",
								"ascii_display": "Affichage ASCII :"
	},
	"map": {
		"sn": "SN matériel:",
		"datalogger": "Nom de l'extracteur de nombres:",
		"address": "Adresse de l'device:"
	},
	"rate": {
		"device_status": "État des devices",
		"datalogger_pn": "datalogger de nombres PN",
		"datalogger_pns": "Nombre datalogger PN:",
		"rate_list": "Liste des tarifs",
		"datalogger_name": "Nombre datalogger nom",
		"status": "l'état",
		"Income_currency": "Monnaie des gains",
		"Income_currencys": "Devise des gains:",
		"generate_Rate": "Taux de production",
		"generate_Rates": "Taux de production d'électricité:",
		"sell_Rate": "Prix de l'électricité",
		"sell_Rates": "Prix de l'électricité vendue:",
		"buy_Rate": "Acheter des tarifs d'électricité",
		"buy_Rates": "Acheter des tarifs d'électricité:",
		"operating": "opérations",
		"edit": "Rédacteur en chef",
		"rate": "taux",
		"cancel": "Annulation",
		"confirm": "déterminer",
		"modifySuc": "Modifié avec succès",
		"resetSuc": "Réinitialiser avec succès",
		"unbindSuc": "Dénouage réussi"
	},
	"auxiliary": {
		"auxiliaryFunction": "La fonction auxiliaire",
		"chartSupplement": "Lissez votre graphique",
		"realChart": "L'affichage du graphique sera lisse après l'ouverture, mais le graphique sera irréel."
	},
	"strategy": {
		"strategyUpgrade": "Liste des politiques de mise à niveau",
		"to": "Retour",
		"UpgFirmware": "Gestion locale du firmware",
		"strategyIntro": "Aperçu du processus de mise à niveau locale",
		"strategyInfor": "Informations sur la politique de mise à niveau",
		"strategyIntro1": "Description: Ce module de fonction est uniquement mis à niveau pour le firmware local Bluetooth, si vous mettez à niveau le firmware d'un périphérique tel que Wi - Fi ou 4G, accédez à [gestion des périphériques - Liste des périphériques - actions de mise à niveau]",
		"stategyStep2": "Ajout du package de version du firmware",
		"stategyStep3": "Télécharger un fichier de package de version du firmware dans local firmware Management",
		"stategyStep4": "Mise à niveau locale app",
		"stategyStep5": "Après l'entrée en vigueur de la politique, l'app reçoit un rappel de mise à niveau qui peut être effectué localement",
		"stategyStep6": "Ajouter stratégie ",
		"stategyStep7": "Ajouter une stratégie dans la liste des stratégies de mise à niveau, cocher mettre à niveau le firmware, définir comment et prendre effet la mise à niveau, associer des périphériques de mise à niveau, générer des stratégies de mise à niveau",
		"stategyStep8": "Voir les enregistrements de mise à niveau",
		"stategyStep9": "Voir l'état et les résultats de la mise à niveau de l'appareil",
		"stategyDetail": "Nom de la politique",
		"stategyDetail1": "Mise à niveau du firmware",
		"stategyDetail2": "Taille du paquet Firmware (KB)",
		"stategyDetail3": "Type de firmware",
		"stategyDetail4": "Taux de Baud",
		"stategyDetail5": "Méthode de mise à niveau",
		"stategyDetail6": "Progression de la mise à niveau",
		"stategyDetail7": "État de la politique",
		"stategyDetail8": "Heure d'entrée en vigueur",
		"stategyDetail9": "Temps de défaillance",
		"upgradeList": "Liste des enregistrements de mise à niveau",
		"add_strategy": "Liste des politiques de mise à niveau",
		"strategy_time": "Temps de validité",
		"strategy_code": "Codage des politiques",
		"strategy_name": "Nom de la politique",
		"strategy_desc": "Description de la Stratégie",
		"strategy_firmware": "Mise à niveau du firmware",
		"strategy_type": "Type de firmware",
		"strategy_baudrate": "Taux de Baud",
		"uprade_type": "Méthode de mise à niveau",
		"uprade_name": "Mise à niveau forcée",
		"uprade_name1": "Mise à niveau recommandée",
		"uprade_result": "Résultats de la mise à niveau",
		"uprade_success": "Mise à niveau réussie",
		"uprade_fail": "Échec de la mise à niveau",
		"uprade_status": "État de la mise à niveau",
		"uprade_time": "Temps de mise à niveau",
		"strategy_number": "Nombre d'objets mis à niveau",
		"strategy_status": "État de la politique",
		"start_time": "Heure d'entrée en vigueur",
		"end_time": "Temps de défaillance",
		"edit": "Modifier",
		"edit_strategy": "Politique éditoriale",
		"view": "Voir",
		"view_strategy": "Voir la Stratégie",
		"cancel": "Annulation",
		"cancel_strategy": "Politique d'annulation",
		"force_upgrade": "Mise à niveau forcée",
		"suggested_upgrade": "Mise à niveau recommandée",
		"In_effect": "En vigueur",
		"expired": "Est invalide",
		"Not_started": "Pas commencé",
		"Not_upgraded": "Pas mis à jour",
		"Yes_started": "Mis à jour",
		"policy_information": "Informations sur la Stratégie",
		"associated_device": "Appareils associés",
		"completion_strategy": "Compléter la Stratégie",
		"upgrade_strategy_list": "Liste des politiques de mise à niveau",
		"Next": "Prochaines étapes",
		"TOP": "Étape précédente",
		"confirm": "Confirmation",
		"go_back": "Retour",
		"strategy_detail": "Détails de la Stratégie",
		"strategy_search": "Code de la politique / nom de la politique",
		"strategy_upgrade_search": "SN/PN",
		"upgrade_remind": "Rappel de mise à niveau",
		"remind_desc": "Description du rappel",
		"default_desc": "Description par défaut",
		"default_desc1": "L'appareil doit être mis à niveau vers une version ultérieure pour être utilisé, appuyez sur 'forcer la mise à niveau' pour la mise à niveau, lors de la mise à niveau, s'il vous plaît ne pas déconnecter la connexion Bluetooth et garantir un réseau lisse.",
		"message_name": "Veuillez entrer le nom de la politique",
		"message_desc": "Veuillez entrer une description de la politique",
		"message_firmware": "Veuillez sélectionner le firmware",
		"message_type": "Veuillez sélectionner le type de firmware",
		"message_baudrate": "Veuillez sélectionner Baud rate",
		"message_timezone": "Veuillez sélectionner un fuseau horaire",
		"message_time": "Veuillez sélectionner une heure valide",
		"message_uprade_type": "Veuillez sélectionner un type de mise à niveau",
		"delete_firmware": "Vous êtes sûr de vouloir annuler cette politique?",
		"delete_desc": "La récupération ne sera pas possible après l'annulation et la stratégie de mise à niveau sélectionnée ne pourra pas informer l'appareil de la mise à niveau",
		"Upgrade_tip": "Veuillez sélectionner le périphérique associé à la politique",
		"Upgrade_result": "Ajouté avec succès",
		"start_date": "Date d'entrée en vigueur",
		"End_date": "Date d'expiration",
		"limits":     "Astuce : dans le fichier téléchargé, la colonne A doit contenir le PN du collecteur de données ; aucun titre n’est requis – voir l’exemple ci-dessous.",
		"mueas":      "Stratégie de mise à jour",
		"upNum":      "Nombre d’appareils à mettre à jour",
		"deletCL":    "Supprimer la stratégie",
		"deletCL_TEST":"Êtes-vous sûr de vouloir supprimer cette stratégie ?",
		"ONE_UP":     "Mise à jour d’un seul appareil",
		"MO_UP":      "Mise à jour en masse des appareils",
		"MO_text": "Importé avec succès",
		"MO_tex1": "Dupliqué",
		"MO_tex3": "Non trouvé",
		"MO_tex2": "Organisation",
		"MO_tex4": "Le firmware est utilisé par une stratégie active, suppression impossible",
		},
	"cloudsUpgarde": {
		"cloudsFirmware": "Mise à niveau du firmware dans le cloud",
		"cloudsFirmwareList": "Liste des mises à niveau vers le cloud"
	},
	"upgradeManagement": {
		"create": "Créer",
		"cancel": "Annulation",
		"confirm": "Confirmation",
		"upload_firmware": "Télécharger le firmware",
		"edit_firmware": "Modifier le firmware",
		"download_firmware": "Télécharger le firmware",
		"delete_desc": "La récupération ne sera pas possible après la suppression et la stratégie de mise à niveau qui a sélectionné ce firmware ne sera pas en mesure de mettre à niveau l'appareil",
		"eidt_success": "Editer avec succès",
		"delete_success": "Annuler avec succès",
		"delete_success1": "Supprimer avec succès",
		"download_success": "En cours de téléchargement",
		"firmware_name": "Nom du paquet firmware",
		"Firmware_Version": "Numéro de version",
		"please_upgrade": "Veuillez sélectionner Upload file",
		"upgrade_success": "Télécharger le firmware avec succès",
		"please_input": "Veuillez entrer",
		"Remarks": "Description du firmware",
		"Upload": "Télécharger le firmware",
		"download_firmware_prompt": "Vous êtes sûr de vouloir télécharger ce firmware?",
		"upgrade_file_format": "Seul le format.Bin /.Hex peut être téléchargé, pas plus de 1MB",
		"upgrade_file_format1": "Seuls les formats.Bin /.Hex peuvent être téléchargés",
		"upgrade_file_format2": "Les fichiers ne peuvent pas dépasser 1MB",
		"firmwareName_empty": "Le nom du firmware ne peut pas être vide",
		"firmwareVersion_empty": "Le numéro de version ne peut pas être vide",
		"download_exception": "Télécharger exception, réessayez plus tard",
		"upload_result": "Résultat du téléchargement",
	},
	"project": {
		"choice": "sélection",
		"move": "mobiles",
		"manageProject": "GestionProjet",
		"project": "Projet à affilier",
		"defaultProject": "Articles par défaut",
		"projectName": "Nom du projet",
		"projectRemark": "Description du projet",
		"projectId": "ID du projet",
		"createProject": "NouveauProjet",
		"createResults": "Nouveaux résultats disponibles",
		"createSuc": "Nouveau succès construit",
		"editProject": "Editer le projet",
		"editResults": "Editer le résultat",
		"editSuc": "Un succès éditorial",
		"delProject": "Supprimer un élément",
		"delResults": "Supprimer le résultat",
		"delSuc": "Supprimé avec succès",
		"upgradeResults": "Résultats de l'escalade",
		"upgradeSuc": "Mise à niveau réussie",
		"back": "Retour",
		"placeholder": "Recherche par nom d'appareil /PN/SN",
		"modifySuc": "Le succès",
		"upload": "Télécharger une image",
		"limit": "(la taille de l'image ne doit pas dépasser 1M)",
		"moveTo": "Se déplacer à",
		"moveSelect": "Déplacer la sélection",
		"deviceSn": "Equipement nt",
		"tipCard": "carte",
		"tipList": "La liste",
		"tipSearchSN": "Recherche par appareil",
		"tipSearchPN": "Recherche par nombre de dataloggers",
		"energyCurrent": "La puissance actuelle",
		"energyDate": "Génération d'électricité jour",
		"energyMonth": "Production d'électricité du mois",
		"energyYear": "Production annuelle d'électricité",
		"energyTotal": "Production totale d'électricité"
	},
	"constant": {
		"renminbi": "Yuan chinois (￥)",
		"meiyuan": "Dollar américain ($)",
		"ouyuan": "Euro (€)",
		"aoyuan": "Dollar australien ($A)",
		"yingbang": "Livre sterling (£)",
		"gangbi": "Dollar de Hong Kong (HK$)",
		"ruidian": "Couronne suédoise (Kr)",
		"lubi": "En roupies indiennes (₹)",
		"moxige": "Peso mexicain (Mex$)",
		"baxi": "Real (R$)",
		"Pakistani": "Roupie pakistanaise (Rs)",
		"Rand": "Rand sud-africain (R)",
		"gmt0": "(GMT +00:00) dublin, edimbourg, lisbonne, londres, casablanca, utc",
		"gmt_1": "(GMT +01:00) paris, madrid, copenhague, rome, vienne, berlin, amsterdam, centrafrique occidentale",
		"gmt_2": "(GMT +02:00) amman, damas, le caire, athènes, jérusalem, istanbul",
		"gmt_3": "(GMT +03:00) bagdad, Koweït, riyad, nairobi, téhéran",
		"gmt_4": "(GMT +04:00) abu dhabi, mascate, erevan",
		"gmt_5": "(GMT +05:00) islamabad, karachi",
		"gmt_55": "(GMT +05:30) new delhi",
		"gmt_6": "(GMT +06:00) dhaka, astana, ekaterinbourg",
		"gmt_65": "(GMT +06:30) Myanmar",
		"gmt_7": "(GMT +07:00) bangkok, hanoi, jakarta, novosibirsk",
		"gmt_8": "(GMT +08:00) pékin, chongqing, Hong Kong sar, urumqi, taipei, kuala lumpur, Singapour",
		"gmt_9": "(GMT +09:00) osaka, tokyo, séoul",
		"gmt_10": "(GMT +10:00) brisbane, Guam, canberra, melbourne, sydney",
		"gmt_11": "(GMT +11:00) iles Salomon, vladivostok, Nouvelle-Calédonie",
		"gmt_12": "(GMT +12:00) auckland, wellington, Fidji, magadan",
		"gmt_13": "(GMT +13:00) nukualofa",
		"gmt_neg_1": "(gmt-01:00) îles du Cap-Vert, açores",
		"gmt_neg_2": "(gmt-02:00) milieu atlantique",
		"gmt_neg_3": "(gmt-03:00) brasilia, buenos aires, groenland, cayenne",
		"gmt_neg_4": "(gmt-04:00) heure de l'atlantique (Canada), cuiaba, la paz, santiago",
		"gmt_neg_5": "(gmt-05:00) heure de l'est (États-Unis et Canada), indiana (est)",
		"gmt_neg_6": "(gmt-06:00) heure centrale (États-Unis et Canada), amérique centrale, mexico city, monterrey, guadalajara",
		"gmt_neg_7": "(gmt-07:00) heure des rocheuses (États-Unis et Canada), chihuahua, la paz, mazatlan, arizona",
		"gmt_neg_8": "(gmt-08:00) heure du pacifique (États-Unis et Canada), basse californie",
		"gmt_neg_9": "(gmt-09:00) alaska",
		"gmt_neg_10": "(gmt-10:00) hawaii",
		"gmt_neg_11": "(gmt-11:00) samoa",
		"gmt_neg_12": "(gmt-12:00) ligne internationale de changement de date ouest"
	},
	"basic": {
		"modifySuc": "Modification réussie!",
		"Personal_info": "Modification des informations",
		"User_name": "Nom d'utilisateur:",
		"User_name1": "Nom de l'utilisateur",
		"Nickname": "Le surnom:",
		"Nickname1": "surnom",
		"editNickname": "Modifier votre pseudo",
		"Ple_Nickname": "Veuillez entrer un surnom",
		"setNickname": "Définir un pseudo",
		"Email": "Adresse mail:",
		"Email1": "Adresse courriel courriel",
		"Email2": "Adresse e-mail:",
		"editEmail": "Changer votre email",
		"setEmail1": "Adresse email liée",
		"Mobile": "Numéro de portable:",
		"Mobile1": "Numéro de téléphone",
		"editMobile": "Changer de numéro de téléphone",
		"setMobile": "Numéro de téléphone mobile lié",
		"Avatar": "Photos de l'utilisateur",
		"basic": "Votre message personnel",
		"Save": "La conservation",
		"Select_all": "Restaurer la sélection complète",
		"Ple_phone": "Veuillez entrer le numéro de téléphone à lier",
		"code": "Code de vérification:",
		"Ple_code": "Veuillez entrer le captcha",
		"Obtain_code": "ObtenirCaptcha",
		"Bind_phone": "Téléphone portable lié",
		"After_bindingPh": "Après avoir lié le téléphone, le mot de passe peut être récupéré via le téléphone",
		"Untie_phone": "Dissocier le téléphone",
		"Change_phone": "Remplacement du téléphone",
		"Bind_email": "Lier une boîte aux lettres",
		"Ple_email": "Veuillez entrer la boîte aux lettres que vous souhaitez lier",
		"re_enter": "Obtenir à nouveau",
		"After_bindingEm": "Après avoir lié l'email, vous pouvez récupérer le mot de passe par email",
		"Unbind_email": "Délier les boîtes aux lettres",
		"Change_email": "Changer votre email",
		"unbind_Ph": "Sûr de délier le numéro de téléphone?",
		"unbinding_Ph": "Vous ne pourrez pas utiliser le téléphone pour récupérer le mot de passe après le délier!",
		"unbind_Em": "Sûr de délier votre boîte aux lettres?",
		"unbinding_Em": "Vous ne pourrez pas utiliser l'email pour récupérer le mot de passe après le déblocage!",
		"mobile_code": "Un code de vérification a été envoyé à votre téléphone. S'il vous plaît vérifier",
		"email_code": "Un code de vérification a été envoyé à votre adresse e-mail. Veuillez le vérifier",
		"suc_ph": "Lier le numéro de téléphone avec succès",
		"suc_em": "Email lié avec succès",
		"code_frequently": "Captcha envoyé fréquemment, veuillez réessayer plus tard",
		"personalCenter": "Paramètres du compte",
		"basicInfo": "Les informations essentielles",
		"accountSecurity": "Sécurité du compte",
		"backTo": "Retour",
		"uploadAvatar": "Changer votre photo de profil",
		"bindPhone": "Binding pour téléphone",
		"bindEmail": "Boîte aux lettres",
		"changePwdTip": "Un mot de passe de haute sécurité peut rendre le compte plus sûr. Nous vous recommandons de changer régulièrement votre mot de passe et d'en définir un de 6 à 32 chiffres.",
		"bindPhoneTipBefore": "Téléphone déjà lié:",
		"bindEmailTipBefore": "Email déjà lié:",
		"bindPhoneTip": "Configurez un téléphone pour vous connecter et récupérer votre mot de passe et recevoir des notifications du système.",
		"bindEmailTip": "Configurez une boîte mail pour vous connecter et récupérer votre mot de passe et recevoir des notifications du système.",
		"bindPhoneTipAfter": "Vous pouvez vous connecter et récupérer votre mot de passe pour recevoir les notifications envoyées par le système.",
		"changeBtn": "La modification",
		"changePwd": "Changer votre mot de passe",
		"changePwdSuc": "Réinitialiser le mot de passe avec succès",
		"finished": "L'achèvement du",
		"retry": "recommencer",
		"changeRes": "Modifier le résultat",
		"bindRes": "Lier les résultats",
		"noHanzi": "Le mot de passe ne doit pas contenir de chinois",
		"Nickname_length_tip": "La longueur du pseudonyme de l'utilisateur est de 2 ~ 32 bits"
	},
	"password": {
		"User_name": "Nom d'utilisateur:",
		"Password": "Changement de mot",
		"Current_password": "Ancien mot de passe",
		"New_password": "Nouveau mot de passe:",
		"Config_newpassword": "Confirmer le nouveau mot de passe",
		"PLCurrent_password": "Veuillez entrer l'ancien mot de passe",
		"PLNew_password": "Veuillez entrer un nouveau mot de passe",
		"PLConfig_newpassword": "Veuillez confirmer le nouveau mot de passe",
		"editPwdSuc": "Changement de mot de passe réussi",
		"loginAgain": "Changement de mot de passe réussi, veuillez vous reconnecter",
		"Save": "La conservation"
	},
	"settingalarm": {
		"chosesstation": "Veuillez sélectionner une centrale",
		"addEmails": "Ajouter une boîte",
		"delete": "Email supprimé avec succès",
		"deletes": "supprimé",
		"Email_List": "Liste de diffusion",
		"Add_Mailbox": "Nouvelle boîte mail push",
		"cancel": "Annulation",
		"Add": "Une augmentation",
		"Email_Setting": "Paramètres de messagerie push",
		"Alarm_Type": "Type d'alarme:",
		"Warning": "témoin",
		"Error": "Les erreurs",
		"Fault": "rappel",
		"Receiving_Report": "Gestion des rapports",
		"Daily_Report": "Déclarations par jour",
		"Monthly_Report": "Déclarations par mois",
		"Yearly_Report": "Déclarations par année",
		"Receiving_Plant": "Les centrales électriques poussées:",
		"E_Mail": "Adresse mail:",
		"Email": "La boîte aux lettres",
		"Plant": "Centrales électriques associées",
		"Operation": "opérations",
		"Alarm_Typetabel": "Type d'alarme disponible",
		"Yes": "est",
		"No": "oui",
		"Delete": "supprimé",
		"suredelete": "Êtes-vous sûr de vouloir supprimer cette boîte mail push?",
		"Delete_Mailbox": "Supprimer une boîte",
		"Add_suc": "Nouveau push email ajouté avec succès!",
		"create": "La création de",
		"list": "Les numéros de série",
		"edit": "Rédacteur en chef"
	},
	"recharge": {
		"cancel": "Annulation",
		"early_warning": "Alerte d'expiration de carte de trafic",
		"orderno": "Numéro de commande",
		"Recharge_tip4": "Recommandé pour les utilisateurs qui se sont inscrits à pay pal",
		"recharge_type": "Type",
		"Recharge_tip3": "Recommandé pour les utilisateurs qui ont déjà installé Wechat",
		"Recharge1": "Recharge du trafic",
		"rechargeStatus": "Statut de recharge",
		"Recharge_tip5": "Paiement Wechat",
		"openWx": "Veuillez ouvrir le téléphone wechat",
		"Hint_language": "Votre appareil existe avec un appareil 2G. À la demande du Ministère du travail et de la communication, la 2G est progressivement retirée du réseau, il est recommandé d'acheter un appareil 4G de remplacement!",
		"rechMoney": "paiement",
		"Recharge": "complément",
		"Recharge_tip": "Rappels de recharge",
		"Dead_Time": "Temps de défaillance",
		"domestic": "Intérieur",
		"not_for_the_time_being": "Pas de traitement",
		"Hint_language1": "Vous rencontrez des problèmes de recharge, veuillez contacter la hotline du service après - vente 0755 - 89993588",
		"rechDiscount": "Déjà en offre",
		"Search": "recherche",
		"warning": "L'alerte rapide",
		"Recharge_tip2": "Veuillez sélectionner par exemple: le même numéro de chargement est 1; Le même type de carte est 4G; La même zone pour la recharge en vrac de la carte de débit de la Chine continentale",
		"Recharge_tip1": "Seules les cartes du même type sont prises en charge pour la recharge par lots",
		"rechScan": "Veuillez ouvrir le téléphone wechat pour balayer et terminer le paiement",
		"rechTip": "Conseils chaleureux: 1, la même commande ne peut choisir que le même type de carte (par exemple, 4G domestique), le même nombre de charges et le même statut de plate - forme de réduction de la pauvreté pour les appareils (le forfait avec une charge de 1 et sans accès à la plate - forme de réduction de la pauvreté est affiché par défaut); 2, le remplissage des cartes en retard et le remplissage du 25 au 5 de chaque mois seront retardés de 1 ~ 14 jours à la facturation, veuillez patienter",
		"Traffic_status": "Statut du trafic",
		"Status": "Statut de carte de trafic",
		"DataloggerPN": "PN:",
		"Recharge_money": "Montant de recharge",
		"Overdue": "Est en retard",
		"Cancel_recharge": "Annuler la recharge",
		"Datalogger_List": "Datalogger Liste",
		"Recharged": "Recharge avec succès",
		"Rcharge_Month": "Nombre de mois de recharge",
		"Service_Area": "Zone de service",
		"Datalogger_PN": "Nombre datalogger PN no.",
		"rechargeDevice": "Pour recharger votre appareil:",
		"rechargeSucInfo": "Vous avez payé avec succès, le trafic arrivera dans les 24 heures",
		"Confirm_recharge": "Confirmer la recharge",
		"scan": "Balayage et paiement",
		"Paid": "Paiement déjà effectué",
		"Time": "Temps de recharge",
		"Unpaid": "Défaut de paiement",
		"Operation": "opérations",
		"Connecting_Devices": "Nombre avec charge",
		"Recharge_reminder": "Rappels de recharge",
		"scanComplete": "Balayez pour terminer le paiement",
		"unknown": "inconnu",
		"rechargeChannel": "Mode de recharge:",
		"Signal": "Valeur du signal",
		"Plant": "Nom de la centrale",
		"rechargeDiscount": "Montant de l'offre:",
		"expired": "Est invalide",
		"load": "Nombre avec charge",
		"Recharge_List": "Liste des recharges",
		"ccid": "Nombre de dataloggers débit cartes cartes non",
		"Order_Number": "Numéro de commande",
		"Package_type": "Types de forfaits",
		"Recharge_record": "Enregistrement de recharge",
		"DataloggerName": "alias",
		"Recharging": "En cours de recharge",
		"Recharge_Selected": "complément",
		"rechargeErr": "Veuillez sélectionner le nombre de dataloggers avec le même nombre de charges",
		"rechargePrice": "Montant de la recharge:",
		"abroad": "À l'étranger",
		"normal": "Normale",
		"previous": "Retour",
		"CCID": "Débit carte carte non",
		"CCID_time": "Temps d'expiration de carte de trafic",
		"serial_number": "Les numéros de série",
		"Activation_Time": "Durée de l'activation",
		"confirm": "Déterminer",
		"Recharge_status": "Statut de recharge",
		"Recharge_now": "Recharger instantanément",
		"Content_warning": "Bonjour cher utilisateur! Constatez que la carte de trafic de l'appareil que vous utilisez arrive à expiration. Si elle n'est pas rechargée à temps, la carte de trafic sera annulée par l'opérateur et ne pourra plus être utilisée. Afin de ne pas affecter votre utilisation normale, veuillez recharger le dispositif avec le statut d'alerte à temps!",
		"Recharge_fail": "Échec de la recharge",
		"rechargePackage": "Forfaits de recharge:",
		"rechargeSuc": "Paiement effectué avec succès",
		"pn": "Nombre datalogger PN no.",
		"Tips": "rappel",
		"Recharge_successful": "Recharge avec succès",
		'Recharge_tip6': "Présence de cartes qui ne supportent pas la recharge,Veuillez contacter l'Administrateur",
		'area_domestic': 'Chine continentale',
		'area_abroad': 'Internationale',
				'remedy_title': 'Remède de commande de recharge',
				'upload_tip': 'Rappel amical : Le format du fichier à télécharger est .txt'
	},
	"customize": {
		"switchSkin": "Changement de peau",
		"classic": "rose",
		"purple": "violet",
		"blue": "Le bleu classique",
		"orange": "Orange douce douce",
		"green": "Frais et vert"
	},
	"firmware": {
		"Firmware_limit_format": "Seuls les formats de fichier .bin, .hex et .s19 sont autorisés",
		"Firmware_upload_fail": "Échec du téléchargement, veuillez réessayer !",
		"Firmware_upload_failTip": "Échec du téléchargement",
		"Firmware_limit1": "Vous pouvez télécharger un maximum de",
		"Firmware_limit2": "fichiers",
		"Firmware_limit3": "firmware",
		"Firmware_limitM": "La taille du fichier firmware individuel ne peut pas dépasser",
		"Firmware_Name": "Nom du firmware",
		"Firmware_desrc": "Description du firmware",
		"Size": "Taille du firmware (KB)",
		"Upload_Time": "Temps de téléchargement",
		"Operation": "opérations",
		"Firmware_List": "Gestion du firmware",
		"Firmware_Lists": "Liste des firmware",
		"Add_Firmware": "Ajouter un firmware",
		"deleteFirmware": "supprimé",
		"Firmware_Version": "Numéro de version",
		"editFirmware": "Modifier",
		"downloadFirmware": "Télécharger",
		"tips": "Conseils",
		"noRecord": "Aucun enregistrement disponible",
		"delete_firmware": "Sûr de vouloir supprimer ce firmware?",
		"del_firmware": "Supprimer le firmware",
		"firmware_upgrade": "Upgrade du firmware",
		"uploadTips": "Veuillez télécharger le fichier firmware",
		"cancel": "Annulation",
		"confirm": "déterminer",
		"Upload_firmware": "Télécharger le firmware",
		"Firmware_description": "Description du firmware:",
		"enter_content": "Veuillez entrer le contenu",
		"Select_file": "Sélection des documents",
		"limit": "Seuls les fichiers au format \".bin\" et \".hex\" peuvent être téléchargés et ne pas dépasser 8M",
		"limit0": "Seuls les fichiers au format \".bin\" et \".hex\" \".s19\"peuvent être téléchargés et ne pas dépasser 8M",
		"limit1": "Seuls les fichiers au format \"XLSX\" peuvent être téléchargés",
		"limit2": "Note d'amitié: le fichier téléchargé A est listé comme PN, B est listé comme alias de datalogger de nombres. Aucun titre n'est nécessaire, vous pouvez vous référer à l'image ci-dessous.",
		"limit3": "Ajouté avec succès",
		"error1": "Seuls les fichiers aux formats \".bin\" et \".hex\" \".s19\" peuvent être téléchargés",
        "error2": " Please press LFU button",
		"deleteSuc": "Supprimé avec succès",
		"UploadTitle": "Veuillez télécharger des fichiers en vrac",
		"Upload": "Télécharger le firmware",
		"Upload1": "Télécharger un fichier",
		"upgrade_quit1": "Exception de mise à niveau, a quitté!",
		"upgrade_quit2": "La mise à jour a échoué, veuillez réessayer plus tard!",
		"upgrade_quit3": "Mise à niveau réussie",
		"upgrade_quit4": "Les mises à niveau sont annulées manuellement",
		"upgrade_quit5": "Pas dans la mise à niveau",
		"upgrade_quit6": "Surclassement annuler",
		"upgrade_quit7": "Échecs de mise à niveau",
		"upgrade_quit8": "Exception de mise à niveau",
		"upgrading": "En cours de modernisation",
		"upgrading1": "Mise à jour connexion en cours, veuillez patienter",
		"updateCompleted": "Mise à niveau terminée",
		"CancelUpgradeSuc": "Annuler la mise à niveau réussie",
		"FailedCancelUpgrade": "Annulation de la mise à niveau échouée",
		"CancelUpgradeSuc11": "Annuler mise à niveau réussie, attendez que le collecteur se connecte au Cloud avant de procéder à la mise à niveau",
		"upgrade_wait": "Préparation de la mise à niveau en cours, veuillez patienter 1 à 2 minutes",
		"upgrade_wait1": "Préparation de la mise à niveau terminée. Veuillez attendre que le collecteur de données soit en ligne, puis relancer la tâche de mise à niveau",
		"colOffline": "Le datalogger est hors ligne",
		"colUpgrading": "Mise à jour déjà en cours",
		"UpgradeStarting": "Mise à niveau démarrée, veuillez patienter...",
		"upgradeSq_fail": "La mise à niveau du datalogger a échoué, veuillez réessayer plus tard !",
	},
	"browse": {
		"usr": "Sous - comptes",
		"email": "Boîte aux lettres",
		"mobile": "Téléphone portable",
		"gts": "Date d'enregistrement",
		"desc": "Remarques",
		"enableStatus": "Activer le statut",
		"Enable": "Activer",
		"Disable": "Désactivé",
		"addBrowse": "Ajouter un sous - compte",
		"pleaseUsr": "Veuillez entrer un sous - compte",
		"accountInfo": "Informations sur le numéro de compte",
		"username": "Nom d'utilisateur",
		"password": "Mot de passe",
		"newPassword": "Nouveau mot de passe",
		"confirmPassword": "Confirmer le mot de passe",
		"usrInfo": "Informations utilisateur",
		"device": "Sélection de projets",
		"pleaseDevice": "Choisir un projet",
		"pleaseDevice_title": "Veuillez sélectionner un projet",
		"pleaseStatus": "Sélectionner un statut",
		"addSuccess": "Ajouter un sous - compte réussi",
		"editSuccess": "Modifier le Sous - compte avec succès",
		"editBrowse": "Modifier un sous - compte",
		"deleteSuccess": "Supprimer avec succès",
		"deleteBrowse": "Supprimer",
		"delete_browse": "Êtes - vous sûr de supprimer un sous - compte?",
		"please_browsepwd": "Veuillez vérifier le nouveau mot de passe et confirmer les exigences de saisie du mot de passe"
	},
	"retrieve": {
		"Retrieve_password": "Récupérer votre mot de passe",
		"Retrieve_passwordPhone": "Récupérer mot de passe sur mobile",
		"Retrieve_passwordEmail": "Email récupérer mot de passe",
		"passwordEmail": "Boîte mail non liée",
		"passwordEmail1": "Les emails ne correspondent pas",
		"passwordPhone": "Numéro de téléphone mobile non lié",
		"passwordPhone1": "Les numéros de téléphone mobile ne correspondent pas",
		"login": "connexion",
		"signup": "l'enregistrement",
		"Enter_account": "Entrez votre compte",
		"Verify_identidy": "Vérifier votre identité",
		"reset_Password": "Réinitialiser votre mot de passe",
		"finish": "L'achèvement du",
		"account_password": "Veuillez entrer le numéro de compte dont vous avez besoin pour récupérer votre mot de passe",
		"username": "Nom de l'utilisateur",
		"Verification_code": "Code de vérification",
		"phone_number": "Téléphone portable non",
		"new_password": "Nouveau login mot de passe",
		"Con_password": "Confirmer le nouveau mot de passe",
		"enter_name": "Veuillez entrer votre nom d'utilisateur",
		"enter_code": "Veuillez entrer le captcha",
		"Change_one": "Changer une photo",
		"confirm": "La confirmation",
		"bound_mobile": "Veuillez entrer un numéro de téléphone mobile lié",
		"Email_verification": "Vérification de l'email",
		"Obtain_code": "ObtenirCaptcha",
		"code_1minute": "Un code de vérification a été envoyé à votre téléphone. Il sera valide dans 1 minute.",
		"Email": "La boîte aux lettres",
		"bound_email": "Veuillez entrer un email obligatoire",
		"Phone_verification": "Vérification par téléphone",
		"code_5minutes": "Un code de vérification a été envoyé à votre adresse e-mail. Valide dans 5 minutes.",
		"New_password": "Nouveau login mot de passe",
		"Confirm_password": "Confirmer le nouveau mot de passe",
		"Reset_successfully": "Réinitialisation du mot de passe réussie. Veuillez garder votre nouveau mot de passe à l'esprit",
		"re-register": "Connectez-vous de nouveau",
		"Incorrect_code": "Le captcha est incorrect",
		"email_first": "Veuillez d'abord remplir votre email",
		"mobile_first": "Veuillez d'abord remplir votre numéro de téléphone portable",
		"Reset_passwordSuc": "Réinitialiser le mot de passe avec succès",
		"Get_codeSucc": "ObtenirCaptcha avec succès",
		"Getting_progress": "En cours d'acquisition, veuillez patienter!",
		"Newloginpassword": "Nouveau login mot de passe",
		"Confirmloginpassword": "Confirmer le nouveau login mot de passe",
		"step1": "Étape 1 étape",
		"step2": "Étape 2 étapes",
		"step3": "Étape 3 étapes",
		"step4": "Étape 4 étapes"
	},
	"errCode": {
		"0": "Normal, aucune erreur",
		"1": "l'échec",
		"2": "Timeout, le système est occupé, veuillez réessayer plus tard",
		"3": "Anomalie système, contactez l'administrateur",
		"4": "Ne pas saisir de caractères spéciaux (signature non vérifiable)",
		"5": "Valeur de sel incorrecte, pas utilisé selon les règles",
		"6": "Paramètre format incorrect",
		"7": "Absence des paramètres nécessaires",
		"8": "Refus de plateforme",
		"9": "Opérations non supportées",
		"10": "Pas authentifié, veuillez vous reconnecter",
		"11": "Opération sans autorisation",
		"12": "Aucun enregistrement disponible",
		"13": "Dépassement des limites",
		"14": "Une opération répétitive",
		"15": "Clé de fabricant non trouvée",
		"16": "Mot de passe incorrect",
		"17": "Mot de passe format incorrect",
		"18": "Le numéro de téléphone est lié, s'il vous plaît changer le numéro de téléphone, ou délier",
		"19": "Numéro de téléphone format incorrect (6<= longueur du numéro <32)",
		"20": "Le format de l'email est incorrect (6<= longueur de l'email <64 et contient le signe @)",
		"21": "Le format du nom d'utilisateur est incorrect (2<= longueur du nom d'utilisateur <32)",
		"22": "Nom de l'entreprise format incorrect",
		"23": "Le code fabricant n'est pas valide, veuillez vérifier que le code est correctement renseigné",
		"24": "Nom d'utilisateur dupliquer",
		"25": "Le compte a été désactivé, veuillez contacter l'administrateur",
		"26": "La boîte aux lettres est liée, Remplacez - la ou Déliez - la",
		"27": "Le compte a été déconnecté. Veuillez contacter l'administrateur",
		"256": "Données non disponibles",
		"257": "De nombreux dataloggers",
		"258": "Aucun devicedisponible",
		"259": "Numéro de PN invalide, veuillez entrer le bon numéro de PN après avoir vérifié",
		"260": "Aucune centrale électrique",
		"261": "Utilisateur introuvable",
		"262": "L'appareil est hors ligne",
		"263": "Le datalogger de nombres est hors ligne",
		"264": "Aucune alarme de dispositif",
		"265": "Pas de détecteur environnemental",
		"271": "Opération sans modification",
		"272": "Répétez le lien",
		"273": "Pas de support pour ajouter les dataloggers de nombres d'autres fabricants",
		"276": "Les propriétaires de centrales mobiles contenant des dataloggers de nombres d'autres fabricants ne sont pas soutenus",
		"288": "Pas de caméra",
		"352": "Sans firmware disponible",
		"353": "Aucun protocole disponible",
		"368": "Aucun rôle disponible",
		"369": "Pas de regroupement d'utilisateurs",
		"370": "Groupement sans centrale",
		"371": "Paquet de recharge de trafic sans GPRS",
		"372": "Commande de recharge sans trafic GPRS",
		"384": "Code de vérification entré incorrectement",
		"385": "Sans device_token",
		"386": "Aucune information de profil d'appareil",
		"387": "D'innombrables types de dataloggers",
		"512": "Le code de vérification SMS ne correspond pas",
		"513": "SMS code de vérification a expiré",
		"514": "Numéro de téléphone/email non lié",
		"515": "Le numéro de téléphone/email ne correspond pas",
		"516": "Nom ne peut pas être du même nom",
		"517": "Il existe encore des dataloggers de nombres sous l'utilisateur ou la centrale",
		"518": "Utilisateurs il existe également des utilisateurs subordonnés",
		"519": "Nom d'utilisateur dupliquer",
		"520": "PN non. Répétition",
		"521": "Les dataloggers de nombres n'appartiennent pas à cet utilisateur",
		"522": "Les dataloggers de nombres existent déjà",
		"523": "Pas un compte spectateur",
		"525": "Code de vérification envoyé, veuillez réessayer dans quelques instants",
		"528": "Le rôle est lié à l'utilisateur et ne peut pas être supprimé",
		"768": "Pas de champs optionnels dans le protocole",
		"772": "Le datalogger a été lié",
		"1024": "Uniquement pour les propriétaires de centrales",
		"1025": "Soutien aux administrateurs uniquement",
		"1026": "Seuls les fabricants d'devicesont pris en charge",
		"1027": "L'utilisateur supérieur doit être un administrateur ou un fabricant d'device",
		"1028": "Méthodes de recharge non supportées",
		"1029": "Nombre de répétitions nombre de dataloggers",
		"1030": "Carte GPRS invalide",
		"1031": "L'utilisateur n'est pas créé par cet administrateur",
		"1041": "La clé est invalide ou introuvable",
		"1042": "CCID invalide",
		"1792": "Les dataloggers de nombres doivent tous appartenir à l'administrateur"
	},
	"controlDeviceErrCode": {
		"1": "L'opération a échoué, veuillez vérifier votre appareil et réessayer!",
		"2": "La réponse a expiré, veuillez réessayer!",
		"3": "Anomalie système, contactez l'administrateur",
		"6": "Format incorrect, veuillez contacter l'administrateur",
		"8": "Refus, veuillez contacter l'administrateur",
		"9": "Opération non prise en charge, veuillez contacter l'administrateur",
		"11": "Aucun droit, veuillez contacter l'administrateur",
		"263": "Le datalogger de nombres est actuellement hors ligne. Veuillez réessayer avant que l'appareil soit en ligne!"
	},
	"control":{
		"setting": "Émission",
		"TouSetting": "Mode de Fonctionnement du Système",
		"touCharge": "Priorité de Charge",
		"touPersonal": "Autoconsommation",
		"touComplete": "Injection Totale dans le Réseau",
		"touClipping": "Réduction des Pics et Remplissage des Creux",
		"touOffgrid": "Application Hors-Réseau",
		"confirmModeSwitch": "Confirmer le Changement de Mode ?",
		"modeSwitch": "Changer de Mode",
		"startTime": "Heure de Début",
		"endTime": "Heure de Fin",
		"paramValue": "Veuillez Sélectionner la Valeur du Paramètre",
		"Monday": "Lundi",
		"Tuesday": "Mardi",
		"Wednesday": "Mercredi",
		"Thursday": "Jeudi",
		"Friday": "Vendredi",
		"Saturday": "Samedi",
		"Sunday": "Dimanche",
		"syncSetDay": "Émission Synchronisée Quotidienne",
		"time": "Période Temporelle 1",
		"time1": "Période Temporelle 2",
		"time2": "Période Temporelle 3",
		"time3": "Période Temporelle 4",
		"time4": "Période Temporelle 5",
		"time5": "Période Temporelle 6",
		"setFail": "Émission Échouée",
		"readFail": "Lecture Échouée",
		"charge": "Charge",
		"discharge": "Décharge",
		"reading": "Lecture Réussie",
		"reading_loading": "Lecture en Cours...",
		"pvMode": "Mode d'Injection dans le Réseau",
		"screenshot": "Capture d'Écran"
	},
	"CollectorCountByOMSOrder": {
		"1": "L'opération a échoué",
		"7": "Manque de paramètres nécessaires",
		"8": "Refusé, veuillez contacter l'Administrateur",
		"12": "Pas de numéro PN de datalogger valide sous la commande, veuillez confirmer le numéro de commande",
		"23": "Code d'usine invalide, veuillez contacter l'Administrateur",
		"259": "Il y a un datalogger invalide sous cette commande, veuillez contacter l'Administrateur",
		"261": "Impossible de trouver le distributeur assigné, veuillez contacter l'Administrateur",
		"772": "Cette commande a déjà un datalogger lié, veuillez confirmer que le datalogger dans la commande n'est pas lié"
	},
	"message": {
		"uname_is_required": "Le compte ne peut pas être vide",
		"id_is_required": "Les groupes ne peuvent pas être vides",
		"pwd_is_required": "Le mot de passe ne peut pas être vide",
		"confpwd_is_required": "Confirmer le mot de passe ne peut pas être vide",
		"invitation_is_required": "Le code d'expérience ne peut pas être vide",
		"pwdAgain": "Veuillez entrer le mot de passe à nouveau",
		"pwdSame": "L'ancien et le nouveau mot de passe ne peuvent pas être identiques",
		"oldPass_wrong": "L'ancien mot de passe est incorrect, veuillez le saisir à nouveau",
		"pwdNotsame": "Deux entrées de mot de passe incohérentes",
		"email_is_required": "L'email ne peut pas être vide",
		"email_info": "Dans 64 adresses e-mail correctes",
		"mobile_is_required": "Le numéro de téléphone ne peut pas être vide",
		"pn_is_required": "PN ne peut pas être vide",
		"PN_info": "Le numéro PN a une longueur de 14 ou 18 chiffres avec une majuscule en premier et ne contient que des majuscules en anglais et en chiffres",
		"nodata": "Données non disponibles",
		"length2_64": "De 2 à 64 caractères",
		"length2_32": "Entre 2 et 32 caractères",
		"length6_20": "Entrez seulement 6-20 lettres, chiffres, soulignements",
		"length6_32": "Entre 6 et 32 caractères",
		"delete_plant": "Supprimer une centrale",
		"modify_plant": "Modification d'une centrale",
		"Exporting_the_report": "Le compte est en cours de déconnexion et ne peut pas se connecter",
		"cancel": "Annulation",
		"search": "recherche",
		"Logging_off": "Le compte est déconnecté et ne peut pas être connecté",
		"country_is_required": "Veuillez sélectionner un pays ou une région",
	},
	"report": {
		"Export_report": "Exporter vos rapports",
		"Subscribe_report": "S'abonner au rapport",
		"all_reports": "Exporter tous les",
		"Report_type": "Type de rapport",
		"Daily_report": "Déclarations par jour",
		"Monthly_report": "Déclarations par mois",
		"Yearly_Report": "Déclarations par année",
		"Total_report": "Le rapport général",
		"customize": "Personnalisé et personnalisé",
		"Report_date": "Date de déclaration:",
		"Report_date1": "Remarque: la date d'exportation ne doit pas dépasser 31 jours",
		"select_date": "Veuillez sélectionner une date",
		"to": "à",
		"start_date": "Date de début",
		"End_date": "Date de fin",
		"cancel": "Annulation",
		"Export": "l'export",
		"download": "Téléchargement en cours, veuillez patienter",
		"Batch_export": "Exporter en lots",
		"current": "Pour le moment",
		"no_deAlarm": "Aucune alarme de l'appareil au cours du dernier mois",
		"Export_alarm": "Exporter une alarme"
	},
	"collectionFrequencyUP": {
		"collect_fast": "Accélération de la collecte du flux d'énergie",
		"collect_fast2": "Accélération du flux énergétique",
		"collect_fast_fail": "Échec de l'accélération, veuillez réessayer",
		"collect_fasting": "En accélération",
		"collect_fast_starting": "Démarrage de l'accélération",
		"collect_fast1": "Accélération de la collecte de données détaillées",
		"collect_fast1ing": "Accélération des données",
		"paySecCon": "Confirmation du paiement",
		"energyFetchPic": "Confirmer ou non la recharge, la plage d'accélération de la recharge est le diagramme de flux d'énergie paramètres de la page comme dans l'image ci - dessous",
		"historyFetchPic": "Confirmez ou non la recharge, la plage d'accélération de la recharge est donnée détails paramètre de la page comme dans l'image ci - dessous",
		"reRechargeTip1": "L'appareil actuel a déjà acheté le service d'accélération du flux d'énergie. Poursuivre l'achat entraînera à nouveau des frais. Voulez-vous continuer ?",
		"reRechargeTip": "L'appareil actuel a déjà acheté le service d'accélération des détails de données. Poursuivre l'achat entraînera à nouveau des frais. Voulez-vous continuer ?",
		"continueRecharge": "Continuer la recharge",
		"collect_fasting_title": "Les paramètres en temps réel ne sont pas stockés",
		"collect_Order_Record": "Enregistrement accéléré",
		"Collection_terms": "Conditions de recharge accélérée de la fréquence d'acquisition",
		"Recharge_failed_next": "Désolé pour l'échec de la recharge, vous pouvez essayer de payer à nouveau",
		"view_order": "Voir les commandes",
		"Once": "Une fois",
		"every_interval": "Les spécifications d'accélération actuellement sélectionnées sont: par intervalle",
		"Collect_terms2": "I. champ d'application du forfait",
		"Collect_terms3": "Paramètres d'affichage inclus dans le protocole utilisé par le collecteur qui s'applique à votre recharge (Remarque: Si vous sélectionnez une page de diagramme de flux pour une recharge accélérée, le forfait s'applique uniquement à la plage de paramètres d'affichage de la page de diagramme de flux; si vous sélectionnez une page de données historiques pour une Recharge accélérée, le forfait s'applique uniquement à la plage de paramètres d'affichage de la page de données historiques)",
		"Collect_terms4": "II. Protocole / équipement de remplacement non pris en charge",
		"have_read": "J'ai suffisamment Lu",
		"Collect_terms5": "Protocole de remplacement / l'équipement ne participe pas au plaisir accéléré",
		"Collect_terms6": "Iii. Désinscription du forfait",
		"Collect_terms": "Acquisition des conditions de recharge accélérée",
		"View_Details": "Voir les détails",
		"Recharge_result": "Résultats de recharge",
		"Collect_terms7": "Désabonnement et changement non pris en charge après paiement",
		"Online_payment": "Paiement en ligne",
		"Collect_terms8": "Iv. Prix du forfait",
		"Collect_terms9": "Notre charge est le prix final calculé en fonction de votre nombre de paramètres, de la fréquence d'acquisition accélérée, du calcul combiné de la charge; Les données historiques concernent, en plus des conditions ci - dessus, le temps de stockage",
		"acquisition_frequency": "Fréquence d'acquisition",
		"Recharge_failed": "Échec de la recharge",
		"Recharge_amount": "Montant de recharge",
		"Scan_payment": "Paiement par Code de balayage",
		"collect_recharge": "Recharge d'accélération de la collecte (accélération de la collecte détaillée)",
		"collect_recharge1": "Recharge d'accélération de la collecte (accélération du flux d'énergie)",
		"Collect_terms10": "V. consommation de trafic",
		"Purchase_Terms7": "Il y a d'autres doutes",
		"Purchase_Terms8": "Si vous avez d'autres questions, contactez notre service clientèle en ligne pour une consultation, nous vous répondrons en détail.",
		"Collect_terms11": "L'accélération de la fréquence d'acquisition aggrave la consommation de trafic",
		"Purchase_Terms6": "Notre charge est le prix final calculé en fonction de votre nombre de paramètres, de la fréquence d'acquisition accélérée, du calcul combiné de la charge; Les données historiques concernent, en plus des conditions ci - dessus, le temps de stockage",
		"Purchase_Terms5": "Prix du forfait",
		"Purchase_Terms4": "S'il vous plaît attendre à notre nouvelle version, la version actuelle ne prend en charge que la mise à niveau de l'acquisition de tous les paramètres d'affichage, ce qui vous gêne s'il vous plaît comprendre!",
		"Purchase_Terms3": "Vous ne pouvez pas personnaliser la mise à niveau de la fréquence d'acquisition de certains paramètres?",
		"Real_parameters": "Paramètres temps réel",
		"Purchase_Terms1": "Période de validité de l'accélération de collecte",
		"Purchase_Terms2": "La date d'expiration du service d'accélération de collecte sera automatiquement calculée en fonction de la durée du forfait que vous avez acheté. La date d'expiration exacte est soumise à l'affichage de la page",
		"device_Info": "Informations sur l'device",
		"Recharge_successful_next": "Félicitations pour votre recharge réussie, nous sommes sur le point de mettre à niveau la fréquence d'acquisition pour vous, vous pouvez suivre vos changements de fréquence d'acquisition à partir du moment",
		"Purchase_Terms": "Conditions d'achat",
		"gather": "Acquisition",
		"Recharge_time": "Temps de recharge",
		"Payment_method": "Mode de paiement",
		"Type": "Type de recharge",
		"Recharge_now": "Recharger instantanément",
		"History_Data": "Données historiques",
		"Collect_terms1": "Conditions d'utilisation du Service accélération des fréquences d'acquisition",
		"Package": "Package accéléré",
		"PN_order": "PN / numéro de commande",
		"Order_No": "Numéro de commande",
		"Recharge_successful": "Recharge avec succès",
		"noRecharg": "Le collecteur ne prend pas en charge la recharge",
		"noRecharg_min": "Votre vitesse de collecte est la plus rapide!",
		"noRecharg_wifi": "La version actuelle ne prend en charge que le module Wi-Fi number Picker",
		"paypalTip": "Le montant final du paiement est soumis à PayPal",
		"upPrice": "Différence de prix",
	},
	alarmNew: {
		'fileName': 'Nom du fichier',
		'fileSize': 'Taille du fichier',
		'fileStatus': 'Statut du fichier',
		'progress': 'Progression',
		'can': 'Téléchargeable',
		'no': 'En cours d\'exportation',
		'history': 'Historique des exports'
	},
		shuoriExport:{
       "exportRecords": "Historique des exports",
       "export": "Exporter",
       "exportTask": "La tâche d’exportation a été créée. Veuillez la télécharger ultérieurement dans l’historique des exports.",
       "noDownload": "L’adresse du fichier est invalide ou ne peut pas être téléchargée. Veuillez réessayer.",
	   'data': 'Date',
	},
		colUnBindRecord: {
	'UnBindRecord': 'Historique de déliaison du collecteur de données',
    "unStatus": "Statut de déliaison",
    "unScene": "Scénario de déliaison",
    "oldUser": "Utilisateur d’origine",
    "newUser": "Nouvel utilisateur",
    "unCount": "Nombre de déliaisons",
    "pnBarCode": "Code-barres PN",
    "devicePicture": "Photo du matériel réel",
    "ip": "IP déliée",
    "unTime": "Heure de déliaison"
	},
		rosRecharge: {
		'electronicInvoicing': 'Facturation électronique',
		'issueEInvoice': 'Émettre une facture électronique',
		'invoiceHistory': 'Historique des factures',
		'rechargeDuration': 'Durée de recharge',
		'year': 'Année',
		'month': 'Mois',
		'day': 'Jour',
		'days': 'Jours',
		'pendingPayment': 'Paiement en attente',
		'paymentSuccess': 'Paiement réussi',
		'paymentFailed': 'Échec du paiement',
		'orderClosed': 'Commande fermée',
		'serviceTerminated': 'Service résilié',
		'unpaid': 'Non payé',
		'paying': 'En cours de paiement',
		'paid': 'Payé',
		'refunded': 'Remboursé',
		'cancelled': 'Annulé',
		'rechargeSuccess': 'Recharge réussie',
		'rechargeFailed': 'Échec de la recharge',
		'pleaseSelectDate': 'Veuillez sélectionner une date',
		'orderNo': 'Numéro de commande',
		'batchInvoicing': 'Facturation en lot',
		'rechargeType': 'Type de recharge',
		'trafficRecharge': 'Recharge de trafic',
		'collectRecharge': 'Recharge de collecte',
		'rechargeStatus': 'État de la recharge',
		'invoice': 'Facture',
		'invoiceStatus': 'État de la facture',
		'invoiceTime': 'Heure de facturation',
		'viewDetail': 'Voir les détails',
		'invoicing': 'En cours de facturation',
		'invoiceSuccess': 'Facture émise',
		'invoiceFailed': 'Échec de l\'emission de la facture',
		'issueElectronicInvoice': 'Émettre une facture électronique',
		'invoiceType': 'Type de facture',
		'generalInvoice': 'Facture ordinaire',
		'specialInvoice': 'Facture spéciale',
		'headerType': 'Type d\'en-tête',
		'companyHeader': 'En-tête d\'entreprise',
		'personalHeader': 'En-tête personnel/non-entreprise',
		'pleaseInputCompanyHeader': 'Veuillez saisir l\'en-tête de l\'entreprise',
		'taxNumber': 'Numéro de TVA de l\'entreprise',
		'pleaseInputTaxNumber': 'Veuillez saisir le numéro d\'identification du contribuable',
		'headerName': 'Nom de l\'en-tête',
		'suggestPersonalName': 'Il est conseillé de saisir le nom personnel/nom du magasin',
		'invoiceContent': 'Contenu de la facture',
		'internetCommService': 'Service de communication Internet',
		'invoiceAmount': 'Montant de la facture',
		'yuan': 'Yuan',
		'moreInfo': 'Plus d\'informations',
		'remarkAddressEtc': 'Remarques, adresse, etc.',
		'companyAddress': 'Adresse de l\'entreprise',
		'pleaseInputCompanyAddress': 'Veuillez saisir l\'adresse de l\'entreprise',
		'companyPhone': 'Téléphone de l\'entreprise',
		'pleaseInputCompanyPhone': 'Veuillez saisir le téléphone de l\'entreprise',
		'openingBank': 'Banque de dépôt',
		'pleaseInputOpeningBank': 'Veuillez saisir la banque de dépôt',
		'bankAccount': 'Numéro de compte bancaire',
		'pleaseInputBankAccount': 'Veuillez saisir le numéro de compte bancaire',
		'remark': 'Remarque',
		'pleaseInputRemark': 'Veuillez saisir une remarque',
		'email': 'E-mail',
		'pleaseInputEmail': 'Veuillez saisir l\'adresse e-mail',
		'cancel': 'Annuler',
		'submit': 'Soumettre',
		'invoiceResult': 'Résultat de la facturation',
		'invoiceSubmitted': 'Demande de facturation soumise',
		'invoiceExpectedTip': 'La facture sera émise dans les 48 heures, veuillez vérifier',
		'viewInvoiceStatus': 'Voir l\'état de la facturation',
		'pleaseInputHeaderName': 'Veuillez saisir le nom de l\'en-tête',
		'pleaseInputValidEmail': 'Veuillez saisir une adresse e-mail valide',
		'invoiceApplyFailed': 'Échec de la demande de facturation',
		'viewInvoice': 'Voir la facture',
		'downloadPdf': 'Télécharger le fichier PDF',
		'manualService': 'Service client',
		'invoiceSentToEmail': 'Les informations de la facture ont été envoyées à l\'e-mail, veuillez vérifier',
		'pleaseWaitInvoicing': 'Veuillez patienter jusqu\'au terme de la facturation',
		'pleaseContactManual': 'Veuillez contacter le service client pour la facturation',
		'noPdfAvailable': 'Aucun fichier PDF disponible au téléchargement',
		'serviceUnavailable': 'Fonction de service client non disponible',

	}
}
export default fr;
